function headerSticky() {
    var html_height = jQuery(document).height(),
        window_height = jQuery(window).height() * 1.5,
        current = jQuery(window).scrollTop(),
        container = jQuery('#offCanvasWrapper'),
        i = jQuery('#header'),
        //point = i.height(),
        point = 0;
    container.css('padding-top', i.height());
    if(html_height > window_height){
        if (i.length) {
            if (current > point) {
                i.addClass('sticky').delay(500).queue(function(next) {
                    i.addClass('delay');
                    next();
                });
            }else{
                i.removeClass('sticky delay');
            }
        }
    }
}
function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
// jQuery(window).on('scroll', headerSticky);
// jQuery(document).on('ready', headerSticky);

jQuery(document).ready(function () {
    jQuery('.toggle-sidebar-menu').click(function(e) {
        e.preventDefault();
        jQuery(this).toggleClass('active').next().slideToggle(200);
    });

    jQuery('.button-play').click(function() {
        var video_id = jQuery(this).parent().find('.video-iframe').data('video-id');
        jQuery(this).parent().addClass('playing').find('.video-iframe').html('<iframe src="//www.youtube.com/embed/' + video_id + '?autoplay=1" frameborder="0" allowfullscreen></iframe>');
    });

    jQuery('.select-dropdown-toggle').click(function(e) {
        e.preventDefault();
        jQuery(this).next().toggleClass('active');
    });

    jQuery('.faqs dt').on('click', function(e){
        e.preventDefault();
        jQuery(this).toggleClass('active').next().slideToggle();
    });

    jQuery('.photo-zoom').featherlight({
        namespace: 'product-photos-zoom',
        targetAttr: 'href',
        type: 'ajax',
        afterContent: function(e) {
            var index = parseInt(this.$currentTarget.data('index'));
            if (jQuery('#product-photos-zoom .owl-carousel').length) {
                jQuery('#product-photos-zoom .owl-carousel').owlCarousel({
                    animateOut: 'fadeOut',
                    loop: true,
                    items: 1,
                    autoplayHoverPause: true,
                    stopOnHover: true,
                    margin: 0,
                    mouseDrag: false,
                    startPosition: index,
                    nav: true,
                    dots: false
                });
            }
            // var winHeight = $(window).height();
            // var $item = $('.product-photos-zoom .photos-zoom-container .item');
            // $('.product-photos-zoom-content .image').mousemove(function(event) {
            //     var a = ($(this).find('img').height() - winHeight) / winHeight;
            //     $(this).css({'background-position-y': -(event.offsetY*a)+'px'});
            // });
        }
    });

    if (jQuery('.collection-description').length) {
        var $desc = jQuery('.collection-description');
        var $inner = jQuery('.collection-description .content');
        if ($desc.height() < $inner.height()) {
            var readmore = '<span class="js-desc-readmore">Read More</span>';
            $desc.addClass('limit');
            $(readmore).insertAfter($desc);
            $('.js-desc-readmore').click(function() {
                $desc.removeClass('limit').addClass('open');
                $(this).hide();
            });
        }
    }

	$(document.body).on('click', '#filterConfirm', function(e) {
        e.preventDefault();
        juno.checkToggleFilter();
    })

    $('#contact_form').submit(function(e) {
        const email = $(this).find('#email').val();

        if(!validateEmail(email)) {
            return false;
        }

        return true;
    })

    var item = sessionStorage.getItem('pageHasBeenLoaded');
    // if (item) {
    //     console.log('this is a reload');
    // }
    sessionStorage.setItem('pageHasBeenLoaded', 'true');

    $(window).unload(function() {
        alert('Handler for .unload() called.');
    });
});



jQuery(document).ready(function() {
    if (jQuery('.product-photos .owl-carousel.main').length) {
        jQuery('.product-photos .owl-carousel.main').owlCarousel({
            animateOut : 'fadeOut',
            items : 1,
            stopOnHover : true,
            margin: 0,
            nav: true,
            dots: true,
            loop: true,
            responsive: {
                992: {
                    nav: false,
                }
            }
        }).on("changed.owl.carousel" , function(el) {
            var thumbs = jQuery('.owl-carousel.thumbnails');
            var count = el.item.count - 1;
            var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

            if (current < 0) {
              current = count;
            }
            if (current > count) {
              current = 0;
            }
            thumbs.find(".owl-item").removeClass("selected").eq(current).addClass("selected");

            var onscreen = thumbs.find(".owl-item.active").length - 1;
            var start = thumbs.find(".owl-item.active").first().index();
            var end = thumbs.find(".owl-item.active").last().index();

            if (current > end) {
                thumbs.data("owl.carousel").to(current, 100, true);
            }
            if (current < start) {
                thumbs.data("owl.carousel").to(current - onscreen, 100, true);
            }
        });
    }
    if (jQuery('.product-photos .owl-carousel.thumbnails').length) {

        if (window.innerWidth > 991) {
            jQuery('.product-photos .owl-carousel.thumbnails').get(0).style.display = "block";
        }

        jQuery('.product-photos .owl-carousel.thumbnails').owlCarousel({
            loop: false,
            stopOnHover : true,
            items: 1,
            margin: 0,
            nav: true,
            dots: false,
            onInitialized: function(event){
                var el = jQuery(event.currentTarget);
                var selected_index = 0;
                el.find('.owl-item.active').eq(selected_index).addClass('selected');
                el.find('.owl-item').click(function(e){
                    e.preventDefault();

                    var index = parseInt(jQuery(this).find('.image').data('index'));
                    el.find('.owl-item').not(jQuery(this)).removeClass('selected');
                    jQuery(this).addClass('selected');
                    // jQuery('.main.owl-carousel .owl-dot').eq(index).trigger('click'); // backup
                    jQuery('.owl-carousel.main').data("owl.carousel").to(index, 300, true);
                });

                el.find('.owl-next').click(function(e){
                    console.log('next = ', selected_index);
                    var index = parseInt(el.find('.owl-item.active .image').data('index'));
                    var selected_index = el.find('.owl-item.selected').index();
                    console.log('next2 = ' , selected_index);
                    el.find('.owl-item').removeClass('selected');
                    el.find('.owl-item').eq(selected_index + 1).trigger('click').addClass('selected');
                    //jQuery('.main.owl-carousel').trigger('next.owl.carousel');
                    jQuery('.owl-carousel.main').data("owl.carousel").to(index, 300, true);
                });

                el.find('.owl-prev').click(function(e){
                    var index = parseInt(el.find('.owl-item.active .image').data('index'));
                    var selected_index = el.find('.owl-item.selected').index();
                    console.log(selected_index);
                    el.find('.owl-item').removeClass('selected');
                    el.find('.owl-item').eq(selected_index - 1).trigger('click').addClass('selected');
                    //jQuery('.main.owl-carousel').trigger('prev.owl.carousel');

                    jQuery('.owl-carousel.main').data("owl.carousel").to(index, 300, true);
                });
            }
        });
    }
    if (jQuery('.product-grid.owl-carousel').length) {
        jQuery('.product-grid.owl-carousel').owlCarousel({
            loop: true,
            autoplay: false,
            margin: 32,
            nav: false,
            dots: false,
            responsive: {
                0: {
                    items: 1
                },
                576: {
                    items: 2
                },
                768: {
                    items: 3
                },
                992: {
                    items: 4
                }
            },
            onInitialized: function(e){
                JunoQuickAdd.init();
            }
        });
    }
    if (jQuery('.blog-featured .articles.owl-carousel').length) {
        jQuery('.blog-featured .articles.owl-carousel').owlCarousel({
            loop: true,
            autoplay: false,
            margin: 20,
            nav: false,
            dots: false,
            responsive: {
                0: {
                    items: 1
                },
                576: {
                    items: 2
                },
                768: {
                    items: 3
                },
                992: {
                    items: 4
                }
            }
        });
    }
});
var juno = {};

var cutsTheMustard = false;
if ('querySelector' in document && 'localStorage' in window && 'addEventListener' in window) {
    cutsTheMustard = true;
    document.documentElement.className = "js";
}

function addClass(whichElement, className) {
    if (whichElement.classList) {
        whichElement.classList.add(className);
    } else {
        whichElement.className += ' ' + className;
    }
}

function removeClass(el, className) {
    if (el.classList) {
        el.classList.remove(className);
    } else {
        el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
}

function hasParent(element, id) {
    if (element) {
        do {
        if (element.id === id) {
            return true;
        }
        if (element.nodeType === 9) {
            // root node
            break;
        }
        }
        while ((element = element.parentNode));
    }
    return false;
}

function array_diff(a1, a2) {
    var a = [], diff = [];
    for (var i = 0; i < a1.length; i++) {
        a[a1[i]] = true;
    }
    for (var i = 0; i < a2.length; i++) {
        if (a[a2[i]]) {
            delete a[a2[i]];
        } else {
            a[a2[i]] = true;
        }
    }
    for (var k in a) {
        diff.push(k);
    }
    return diff;
}


function array_remove(arr, value) { 
    return arr.filter(function(ele){ 
        return ele != value; 
    });
}
function is_touch_device() {
    return (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}
jQuery(document).ready(function() {
	jQuery('.nav-primary li.level0').hover(function() {
        jQuery(this).addClass('active').parent().addClass('hover');
        if(jQuery(this).hasClass('parent')){
            jQuery(this).find('.nav-drop').addClass('is-open');
        }
	}, function() {
        jQuery(this).removeClass('active').parent().removeClass('hover');
        if(jQuery(this).hasClass('parent')){
            jQuery(this).find('.nav-drop').removeClass('is-open');
        }
    });
    // console.log('data!!!!!!!!!!!!!!')
    jQuery('.closeToggle').click(function() {
        $nav = jQuery(this).parents('.nav').eq(0);
        $parent = jQuery(this).parents('.parent').eq(0);
        $nav.removeClass('is-open');
        $parent.removeClass('is-open');
        removeClass(document.documentElement, 'offCanvasNavSubMenu');
    })
    
    jQuery('.nav-functions li').hover(function() {
        jQuery(this).addClass('active').parent().addClass('hover');
	}, function() {
        jQuery(this).removeClass('active').parent().removeClass('hover');
    });
    
    jQuery('.nav-primary .toggle').click(function(e) {
        $nav = jQuery(this).parents('.nav').eq(0);
        $parent = jQuery(this).parents('.parent').eq(0);
        if($nav.hasClass('is-open')){
            $nav.removeClass('is-open');
            $parent.removeClass('is-open');
            removeClass(document.documentElement, 'offCanvasNavSubMenu');
        }else{
            $nav.addClass('is-open');
            $parent.addClass('is-open');
            addClass(document.documentElement, 'offCanvasNavSubMenu');
        }
    });

    jQuery('.nav-additional h6').click(function(e) {
        jQuery(this).toggleClass('active').next().slideToggle();
	});
});

if (cutsTheMustard) {
	juno.navIsRevealed = false;
	juno.cartIsRevealed = false;
	juno.searchIsRevealed = false;
	juno.userIsRevealed = false;
	juno.filterIsRevealed = false;
	juno.wishListIsRevealed = false;
	// toggle with the menu button:

    var navToggle = document.getElementById('navToggle');
    if(navToggle){
        navToggle.addEventListener('click', function(e) {
            juno.checkToggleNavigation();
            if (e) {
                e.preventDefault();
            }
        }, false);
        juno.checkToggleNavigation = function() {
					if (juno.navIsRevealed) {
						removeClass(navToggle, 'active');
						removeClass(document.documentElement, 'offCanvasNav');
						juno.navIsRevealed = false;
					} else {
						addClass(navToggle, 'active');
						addClass(document.documentElement, 'offCanvasNav');
						juno.navIsRevealed = true;
					}
        };
    }

    var cartToggle = document.getElementById('cartToggle');
    if(cartToggle){
        cartToggle.addEventListener('click', function(e) {
            juno.checkToggleBasket();
            if (e) {
                e.preventDefault();
            }
        }, false);
        juno.checkToggleBasket = function() {
            if (juno.cartIsRevealed) {
				removeClass(cartToggle, 'active');
				removeClass(document.documentElement, 'offCanvas');
                removeClass(document.documentElement, 'offCanvasBasket');
                juno.cartIsRevealed = false;
            } else {
				addClass(cartToggle, 'active');
				addClass(document.documentElement, 'offCanvas');
                addClass(document.documentElement, 'offCanvasBasket');
                juno.cartIsRevealed = true;
            }
        };
    }

    var wishListToggle = document.getElementById('wishlistToggle');
    if(wishListToggle) {
    	wishListToggle.addEventListener('click', function(e) {
            juno.checkToggleWishlist();
            if (e) {
                e.preventDefault();
            }
        }, false);
        juno.checkToggleWishlist = function() {
            if (juno.wishListIsRevealed) {
                removeClass(document.documentElement, 'offCanvasWishList');
                juno.wishListIsRevealed = false;
            } else {
                addClass(document.documentElement, 'offCanvasWishList');
                juno.wishListIsRevealed = true;
            }
        };
    }

    var searchToggle = document.getElementById('searchToggle');
    if(searchToggle){
        searchToggle.addEventListener('click', function(e) {
            juno.checkToggleSearch();
            if (e) {
                e.preventDefault();
            }
        }, false);
        juno.checkToggleSearch = function() {
            if (juno.searchIsRevealed) {
				removeClass(searchToggle, 'active');
				removeClass(document.documentElement, 'offCanvas');
                removeClass(document.documentElement, 'offCanvasSearch');
                juno.searchIsRevealed = false;
            } else {
				addClass(searchToggle, 'active');
				addClass(document.documentElement, 'offCanvas');
                addClass(document.documentElement, 'offCanvasSearch');
                document.getElementById('search-input').focus();
                juno.searchIsRevealed = true;
            }
        };
    }

	var userToggle = document.getElementById('userToggle');
    if(userToggle){
        userToggle.addEventListener('click', function(e) {
            juno.checkToggleUser();
            if (e) {
                e.preventDefault();
            }
        }, false);
        juno.checkToggleUser = function() {
            if (juno.userIsRevealed) {
				removeClass(userToggle, 'active');
				removeClass(document.documentElement, 'offCanvas');
                removeClass(document.documentElement, 'offCanvasUser');
                juno.userIsRevealed = false;
            } else {
				addClass(userToggle, 'active');
				addClass(document.documentElement, 'offCanvas');
                addClass(document.documentElement, 'offCanvasUser');
                juno.userIsRevealed = true;
            }
        };
    }


    var filterToggle = document.getElementById('filterToggle');
	if(filterToggle){
		filterToggle.addEventListener('click', function(e) {
			juno.checkToggleFilter();
			if (e) {
				e.preventDefault();
			}
        }, false);
        juno.checkToggleFilter = function() {
            if (juno.filterIsRevealed) {
                removeClass(document.documentElement, 'offCanvasFilter');
                juno.filterIsRevealed = false;
            } else {
                addClass(document.documentElement, 'offCanvasFilter');
                juno.filterIsRevealed = true;
            }
        };
	}


	juno.checkCloseNavigation = function(e) {
		if (juno.navIsRevealed) {
			// check it's not the menu icon (or its children) itself as this will trigger independently (and would cause the event to be fired twice)
			if ((e.target.id != 'navToggle') && (!hasParent(e.target, 'navToggle'))) {
				// check the click isn't within the nav panel:
				if (!hasParent(e.target, 'navigation')) {
					removeClass(document.documentElement, 'offCanvasNav');
					juno.navIsRevealed = false;
					e.preventDefault();
				}
			}
		}
	};
	juno.checkCloseWishlist = function(e) {
		// check the click isn't within the nav panel:
		if (!hasParent(e.target, 'wishlistOutput')) {
			removeClass(document.documentElement, 'offCanvasWishList');
			juno.wishListIsRevealed = false;
			//e.preventDefault();
		}
	};
	juno.checkCloseBasket = function(e) {
		if (juno.cartIsRevealed) {
			// check it's not the menu icon itself as this will trigger independently (and would cause the event to be fired twice)
			if ((e.target.id != 'cartToggle') && (!hasParent(e.target, 'cartToggle'))) {
				// check the click isn't within the nav panel:
				if (!hasParent(e.target, 'cartContainer')) {
					removeClass(cartToggle, 'active');
					removeClass(document.documentElement, 'offCanvas');
					removeClass(document.documentElement, 'offCanvasBasket');
					juno.cartIsRevealed = false;
					e.preventDefault();
				}
			}
		}
	};
	juno.checkCloseSearch = function(e) {
		if (juno.searchIsRevealed) {
			// check it's not the menu icon itself as this will trigger independently (and would cause the event to be fired twice)
			if ((e.target.id != 'searchToggle') && (!hasParent(e.target, 'searchToggle'))) {
				// check the click isn't within the nav panel:
				if (!hasParent(e.target, 'searchContainer')) {
					// hide navigation:
					removeClass(searchToggle, 'active');
					removeClass(document.documentElement, 'offCanvas');
					removeClass(document.documentElement, 'offCanvasSearch');
					juno.searchIsRevealed = false;
					e.preventDefault();
				}
			}
		}
	};
	juno.checkCloseUser = function(e) {
		if (juno.userIsRevealed) {
			// check it's not the menu icon itself as this will trigger independently (and would cause the event to be fired twice)
			if ((e.target.id != 'userToggle') && (!hasParent(e.target, 'userToggle'))) {
				// check the click isn't within the nav panel:
				if (!hasParent(e.target, 'userContainer')) {
					// hide navigation:
					removeClass(userToggle, 'active');
					removeClass(document.documentElement, 'offCanvas');
					removeClass(document.documentElement, 'offCanvasUser');
					juno.userIsRevealed = false;
					e.preventDefault();
				}
			}
		}
	};
	juno.checkCloseFilter = function(e) {
		if (juno.filterIsRevealed) {
			// check it's not the menu icon itself as this will trigger independently (and would cause the event to be fired twice)
			if ((e.target.id != 'filterToggle') && (!hasParent(e.target, 'filterToggle'))) {
				// check the click isn't within the nav panel:
				if (!hasParent(e.target, 'filterContainer')) {
					// hide navigation:
					removeClass(document.documentElement, 'offCanvasFilter');
					juno.filterIsRevealed = false;
					e.preventDefault();
				}
			}
		}
	};
	// close by touching the visible part of the content:
	document.addEventListener('click', function(e) {
		juno.checkCloseNavigation(e);
		juno.checkCloseBasket(e);
		juno.checkCloseSearch(e);
		juno.checkCloseUser(e);
		juno.checkCloseFilter(e);
		if(wishListToggle) {
			juno.checkCloseWishlist(e);
		}
	}, true);
	// double up for mobile event:
	document.addEventListener('touchend', function(e) {
		juno.checkCloseNavigation(e);
		juno.checkCloseBasket(e);
		juno.checkCloseSearch(e);
		juno.checkCloseUser(e);
		juno.checkCloseFilter(e);
		if(wishListToggle) {
			juno.checkCloseWishlist(e);
		}
	});

	juno.swipeLeft = function() {
		if (juno.navIsRevealed) {
			removeClass(document.documentElement, 'offCanvas');
			juno.navIsRevealed = false;
		}
		if (juno.filterIsRevealed) {
			removeClass(document.documentElement, 'offCanvasFilter');
			juno.filterIsRevealed = false;
		}
	};
	juno.swipeRight = function() {
		if (juno.cartIsRevealed) {
			removeClass(document.documentElement, 'offCanvasBasket');
			juno.cartIsRevealed = false;
		}
		if(wishListToggle) {
			removeClass(document.documentElement, 'offCanvasWishList');
			juno.wishListIsRevealed = false;
		}
	};
	// init touch:
	if ('ontouchstart' in document.documentElement) {
		document.body.addEventListener('touchstart', function(a) {
			startPointX = a.touches[0].pageX;
			startPointY = a.touches[0].pageY;
			isScrolling = '';
			deltaX = 0;
		}, false);
		document.body.addEventListener('touchmove', function(a) {
			if (a.touches.length > 1 || a.scale && a.scale !== 1) {
				return;
			}
			deltaX = a.touches[0].pageX - startPointX;
			if (isScrolling === '') {
				isScrolling = (isScrolling || Math.abs(deltaX) < Math.abs(a.touches[0].pageY - startPointY));
			}
			if (!isScrolling) {
				a.preventDefault();
			}
		}, false);
		document.body.addEventListener('touchend', function(a) {
			if (!isScrolling) {
				if ((Math.abs(deltaX)) > 100) {
					if (deltaX < 0) {
						juno.swipeLeft();
					} else {
						juno.swipeRight();
					}
				}
			}
		}, false);
	}
}
var JunoQuickAdd = (function(module, $) {
    'use strict';
      
    // Public functions
    var init;
    
    // Private general variables
    var settings, variantID, firstOptionValue, secondOptionValue, thirdOptionValue, firstOptionPostion, secondOptionPostion, thirdOptionPostion;
    
    // Private plugin variables
    var $productItem, $productQuickAdd, $productOptions, $productOption, $selectOption, $selectOptionSize, $elementSelectOption, $firstOption, $secondOption, $thirdOption;
    
    // Private functions
    var addToCart, selectVariant, optionUnavailable, checkOptionOutOfStock, defaultColourSelected;

    init = function (options) {
        settings = {
            productItem        : '.product-item',
            productQuickAdd    : '.product-quick-add',
            productOptions     : '.product-options-select',
            selectOption       : '.select-option',
            firstOption        : '.first-option',
            secondOption       : '.second-option',
            thirdOption        : '.third-option'
        };

        $productItem         = $(settings.productItem);
        $productQuickAdd     = $productItem.find(settings.productQuickAdd);
        $productOptions      = $productQuickAdd.find(settings.productOptions);
        $selectOption        = $productQuickAdd.find(settings.selectOption);
        $elementSelectOption = $selectOption.find('li');

        //Select Variant
        defaultColourSelected();
        selectVariant();
        optionUnavailable();
    }

    // Has Colour Variant
    defaultColourSelected = function() {
        $productItem.each(function(){
            $productItem     = $(this);
            $productQuickAdd = $productItem.find(settings.productQuickAdd);
            $productOptions  = $productItem.find(settings.productOptions);
            $firstOption     = $productItem.find(settings.firstOption);
            $secondOption    = $productItem.find(settings.secondOption);
            $thirdOption     = $productItem.find(settings.thirdOption);
            if($firstOption.hasClass('colour-option')){
                $firstOption.find('li').not('.out-of-stock').eq(0).addClass('selected');
            }else{
                return;
            }
        });
    }

    selectVariant = function() {
        $elementSelectOption.on('click', function(e){
            e.preventDefault();

            var $this = $(this), $thisValue, $thisSelectOption, $thisOptionPosition, $thisOptionIndex, $option, $optionValue;

            if($this.hasClass('selected') || $this.hasClass('out-of-stock') || $this.hasClass('unavailable')){
                return;
            }

            $productItem        = $this.parents(settings.productItem).eq(0);
            $productQuickAdd    = $productItem.find(settings.productQuickAdd);
            $productOptions     = $productItem.find(settings.productOptions);
            $selectOption       = $productItem.find(settings.selectOption);
            $selectOptionSize   = $productOptions.data('size');
            $firstOption        = $productQuickAdd.find(settings.firstOption);
            $secondOption       = $productQuickAdd.find(settings.secondOption);
            $thirdOption        = $productQuickAdd.find(settings.thirdOption);

            $thisValue          = $this.data('value');
            $thisSelectOption   = $this.parents(settings.selectOption).eq(0);
            $thisOptionPosition = $thisSelectOption.data('option');
            $thisOptionIndex    = $thisSelectOption.data('index');

            if($thisSelectOption.hasClass('colour-option')){
                $this.addClass('selected');
                $thisSelectOption.find('li').not($this).removeClass('selected');
            }else{
                firstOptionValue = $firstOption.find('li.selected').data('value');
                firstOptionPostion = $firstOption.data('option');
                switch($thisOptionIndex) {
                    case 1:
                        firstOptionValue = $thisValue;
                        firstOptionPostion = $thisOptionPosition;
                        break;
                    case 2:
                        secondOptionValue = $thisValue;
                        secondOptionPostion = $thisOptionPosition;
                        break;
                    case 3:
                        thirdOptionValue = $thisValue;
                        thirdOptionPostion = $thisOptionPosition;
                        break;
                }
                if($selectOptionSize == $thisOptionIndex){
                    switch($selectOptionSize) {
                        case 1:
                            $productOption = $productOptions.find('option[data-'+ firstOptionPostion +'='+ firstOptionValue +']');
                            $option = $firstOption;
                            $optionValue = firstOptionValue;
                            variantID = $productOption.val();
                            break;
                        case 2:
                            $productOption = $productOptions.find('option[data-'+ firstOptionPostion +'='+ firstOptionValue +'][data-'+ secondOptionPostion +'='+ secondOptionValue +']');
                            $option = $secondOption;
                            $optionValue = secondOptionValue;
                            variantID = $productOption.val();
                            break;
                        case 3:
                            $productOption = $productOptions.find('option[data-'+ firstOptionPostion +'='+ firstOptionValue +'][data-'+ secondOptionPostion +'='+ secondOptionValue +'][data-'+ thirdOptionPostion +'='+ thirdOptionValue +']');
                            $option = $thirdOption;
                            $optionValue = thirdOptionValue;
                            variantID = $productOption.val();
                            break;
                    }
                    // Add to Cart
                    addToCart($productItem, variantID);
                }else{
                    //optionUnavailable($this, firstOptionValue, secondOptionValue, thirdOptionValue);
                    $this.addClass('selected');
                    $thisSelectOption.hide().next().show();
                }
            }
            
        });
    }

    optionUnavailable = function($this, firstOptionValue, secondOptionValue, thirdOptionValue) {
        var $firstOption, $secondOption, $thirdOption, $dataFirstOptionValue, $dataSecondOptionValue, $dataThirdOptionValue, $dataInventoryQuantity, $dataVariantID, $optionOutOfStock;

        if($this){
            $productItem         = $this.parents(settings.productItem).eq(0);
            $productQuickAdd     = $productItem.find(settings.productQuickAdd);
            $productOptions      = $productQuickAdd.find(settings.productOptions);
            $selectOption        = $productQuickAdd.find(settings.selectOption);
            $elementSelectOption = $selectOption.find('li');

            //First Option
            if($productQuickAdd.find(settings.firstOption).length > 0){
                $firstOption = $productQuickAdd.find(settings.firstOption);
                firstOptionPostion = $firstOption.data('option');
            }
            //Second Option
            if($productQuickAdd.find(settings.secondOption).length > 0){
                $secondOption = $productQuickAdd.find(settings.secondOption);
                secondOptionPostion = $secondOption.data('option');
            }
            //Third Option
            if($productQuickAdd.find(settings.thirdOption).length > 0){
                $thirdOption = $productQuickAdd.find(settings.thirdOption);
                thirdOptionPostion = $thirdOption.data('option');
            }

            //Out of Stock 
            if($firstOption != undefined){
                if(firstOptionValue != null){
                    $elementSelectOption.removeClass('selected out-of-stock unavailable');
                    if($thirdOption == undefined){
                        // Two Options
                        if($secondOption != undefined){
                            var $secondOptionValues = [], $secondOptionAvailableValues = [], $secondOptionUnavailableValues = [];

                            $secondOption.find('li').removeClass('selected out-of-stock unavailable').each(function(){
                                $secondOptionValues.push($(this).data('value'));
                            });

                            $productOptions.find('option').each(function(){
                                $dataFirstOptionValue = $(this).data(firstOptionPostion);
                                $dataSecondOptionValue = $(this).data(secondOptionPostion);
                                $dataInventoryQuantity = parseInt($(this).data('inventory_quantity'));
                                
                                if($dataFirstOptionValue == firstOptionValue){
                                    $secondOptionAvailableValues.push($dataSecondOptionValue);
                                    if($dataInventoryQuantity < 1){
                                        $optionOutOfStock = $dataSecondOptionValue;
                                        $secondOption.find('li').each(function() {
                                            if($(this).data('value') == $optionOutOfStock){
                                                $(this).addClass('out-of-stock');
                                            }
                                        });
                                    }
                                    //checkOptionOutOfStock($(this), $secondOption, $dataSecondOptionValue);
                                }
                            });

                            $secondOptionUnavailableValues = array_diff($secondOptionValues,$secondOptionAvailableValues);
                            if($secondOptionUnavailableValues.length > 0){
                                $secondOptionUnavailableValues.forEach(function(unavailableValue,index){
                                    $secondOption.find('li').each(function() {
                                        if($(this).data('value') == unavailableValue){
                                            $(this).addClass('unavailable');
                                        }
                                    });
                                });
                            }
                        }
                    }else{
                        // Three Options
                        var $thirdOptionValues = [], $thirdOptionAvailableValues = [], $thirdOptionUnavailableValues = [];

                        $thirdOption.find('li').removeClass('selected out-of-stock unavailable').each(function(){
                            $thirdOptionValues.push($(this).data('value'));
                        });
                        $productOptions.find('option').each(function(){
                            $dataFirstOptionValue = $(this).data(firstOptionPostion);
                            $dataSecondOptionValue = $(this).data(secondOptionPostion);
                            $dataThirdOptionValue = $(this).data(thirdOptionPostion);
                            $dataInventoryQuantity = parseInt($(this).data('inventory_quantity'));
                            
                            if($dataFirstOptionValue == firstOptionValue && $dataSecondOptionValue == secondOptionValue){
                                $thirdOptionAvailableValues.push($dataThirdOptionValue);
                                if($dataInventoryQuantity < 1){
                                    $optionOutOfStock = $dataThirdOptionValue;
                                    $thirdOption.find('li').each(function() {
                                        if($(this).data('value') == $optionOutOfStock){
                                            $(this).addClass('out-of-stock');
                                        }
                                    });
                                }
                                //checkOptionOutOfStock($(this), $thirdOption, $dataThirdOptionValue);   
                            }
                        });

                        $thirdOptionUnavailableValues = array_diff($thirdOptionValues,$thirdOptionAvailableValues);
                        if($thirdOptionUnavailableValues.length > 0){
                            $thirdOptionUnavailableValues.forEach(function(unavailableValue,index){
                                $thirdOption.find('li').each(function() {
                                    if($(this).data('value') == unavailableValue){
                                        $(this).addClass('unavailable');
                                    }
                                });
                            });
                        }
                    }
                }
            }
        }else{
            // One Option
            $productItem.each(function(){
                $productItem       = $(this);
                $productQuickAdd   = $productItem.find(settings.productQuickAdd);
                $productOptions    = $productItem.find(settings.productOptions);
                $selectOption      = $productItem.find(settings.selectOption);
                $selectOptionSize  = $selectOption.size();
                $firstOption       = $productItem.find(settings.firstOption);
                firstOptionPostion = $firstOption.data('option');

                //Out of stock
                if($selectOptionSize == 1 && $firstOption != undefined){
                    $firstOption.find('li').removeClass('selected out-of-stock unavailable');

                    $productOptions.find('option').each(function(){
                        $dataVariantID = $(this).val();
                        $dataFirstOptionValue = $(this).data(firstOptionPostion);
                        $dataInventoryQuantity = parseInt($(this).data('inventory_quantity'));

                        if($dataInventoryQuantity < 1){
                            $optionOutOfStock = $dataFirstOptionValue;
                            $firstOption.find('li').each(function() {
                                if($(this).data('value') == $optionOutOfStock){
                                    $(this).addClass('out-of-stock');
                                }
                            });
                        }
                        //checkOptionOutOfStock($(this), $firstOption, $dataFirstOptionValue);
                    });
                }
                if($firstOption.hasClass('colour-option')){
    
                }
            }); 
        }
    };

    checkOptionOutOfStock = function($productOption, $option, $optionValue) {
        var $dataVariantID, $dataInventoryQuantity, $optionOutOfStock;

        $dataVariantID = $productOption.val();
        $dataInventoryQuantity = parseInt($productOption.data('inventory_quantity'));
        $.getJSON('/cart.js', function (cart) {
            jQuery.each(cart.items, function(index, item) {
                if (item.id == $dataVariantID) {
                    $dataInventoryQuantity = $dataInventoryQuantity - parseInt(item.quantity);
                    if($dataInventoryQuantity < 1){
                        $optionOutOfStock = $optionValue;
                        $option.find('li').each(function() {
                            if($(this).data('value') == $optionOutOfStock){
                                $(this).addClass('out-of-stock');
                            }
                        });
                    }
                }
            })
        });
    };

    addToCart = function($product, variantID) { 
        $.post('/cart/add.js', {quantity: 1,id: variantID}, null, 'json').done(function(data) {
            ajaxCart.load();
            $product.addClass('hover').find(settings.selectOption).removeAttr('style').delay(3600).queue(function(rvt) {
                $product.removeClass('hover');
            })
            $product.find('.product-options').append('<span class="message">Added to bag</span>').delay(3650).queue(function(rvt) {
                $product.find('.message').remove();
                rvt();
            });
        }).fail(function(data) {
            var error = data.status;
            if(data.status == 422){
                error = 'Sorry, Sold Out';
            }
            if(data.status == 400){
                error = 'Sorry, Unavailable';
                
            }
            $product.addClass('hover').find(settings.selectOption).removeAttr('style').delay(3600).queue(function(rvt) {
                $product.removeClass('hover');
            })
            $product.find('.product-options').append('<span class="message">'+ error +'</span>').delay(3650).queue(function(rvt) {
                $product.find('.message').remove();
                rvt();
            });
        });
    }

    module = {
        init: init
    };
    
    return module; 

}(JunoQuickAdd || {}, jQuery));

// jQuery(document).ready(function () {
//     JunoQuickAdd.init();
// });
var JunoQuickViewProducts = (function(module, $) {
    'use strict';
      
    // Public functions
    var init;
    
    // Private general variables
    var settings, button;
    
    // Private plugin variables
    //var $button;
    
    // Private functions

    init = function (options) {
        settings = {
            button: '.view-products',
            close: '.close-view-products'
        };

        $(document).on('click', settings.button, function(e) {
            e.preventDefault();

            var $this = $(this), 
                number = parseInt($this.data('number')), 
                ajaxUrl = $this.attr('href') + '?view=ajax';

            if($(this).hasClass('active')){
                $(this).removeClass('active').parent().removeClass('show');
            }else{
                $(this).addClass('active').parent().addClass('show');
            }

            if($this.hasClass('render')){
                return;
            }else{
                $.ajax({
                    type: 'GET',
                    url: ajaxUrl,
                    processData: false,
                    contentType: false,
                    success: function(data) {
                        var render = false, item;
                        $(data).filter('.product-grid').find('.product-item').each(function(index, value){
                            if(index < number){
                                render = true;
                                item = $('<div>').append($(this)).html();
                                $this.parent().find('.products').append(item);
                            }else{
                                return;
                            }
                        });
                        if(render == true){
                            $this.addClass('render');
                        }
                    }
                });
            }            
        });
        $(document).on('click', settings.close, function(e) {
            e.preventDefault();

            var $this = $(this),
                parent = $(this).parents('.quick-view-products').eq(0);

            parent.removeClass('show');
            parent.find(settings.button).removeClass('active');
        });
        $(document).on('click', '.quick-view-products .products-container', function(e) {
            var $target = $(e.target),
                $this = $(this),
                parent = $(this).parents('.quick-view-products').eq(0);
        
            if(!$target.closest('.products').length){
                parent.removeClass('show');
                parent.find(settings.button).removeClass('active');
            }
        });
    }


    module = {
        init: init
    };
    
    return module; 

}(JunoQuickViewProducts || {}, jQuery));
jQuery(document).ready(function () {
    JunoQuickViewProducts.init();
});
getJSON = function(url, successHandler, errorHandler) {
    var xhr = typeof XMLHttpRequest != 'undefined' ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
    xhr.withCredentials = true;
    xhr.open('get', url, true);
    xhr.onreadystatechange = function() {
        var status, data
        if (xhr.readyState == 4) {
            status = xhr.status;
            var wasParsedOk = true;
            if (status == 200) {
                try {
                    data = JSON.parse(xhr.responseText);
                } catch (e) {
                    // JSON parse error:
                    wasParsedOk = false;
                    errorHandler && errorHandler(status);
                }
                if (wasParsedOk) {
                    successHandler && successHandler(data);
                }
            } else {
                errorHandler && errorHandler(status);
            }
        }
    };
    xhr.send();
};

function getWishlist(reveal) {
    jQuery('#wishlistOutput').addClass("loading");
    var url;
    if(typeof junoWishlistCustomer !== "undefined") {
        url = 'http://pwaify.com/wishlist/?customer-id='+junoWishlistCustomer+'&shop='+junoWishlistStore;
    } else {
        // use local storage
        var currentWishList = getLocalStorageWishList();
        url = 'http://pwaify.com/wishlist/local.php?product-ids='+JSON.stringify(currentWishList)+'&type=get&shop='+junoWishlistStore+'&return='+encodeURIComponent(window.location.pathname);
    }
    getJSON(url, function(data) {
        if (data.html) {
            // done
            jQuery('#wishlistOutput').removeClass("loading").html(data.html);
            if(reveal) {
                juno.wishListIsRevealed = true;
                jQuery('html').addClass("offCanvasWishList");
            }
        }
    }, function(status) {
        // error
    });
}

function addToWishList(productId, $elem = null) {
    var url = 'http://pwaify.com/wishlist/?customer-id='+junoWishlistCustomer+'&type=set&update=add&product-id=' + productId + '&shop='+junoWishlistStore;
    getJSON(url, function(data) {
        if (data.completed == "true") {
            // done
            $('#productWishListWrapper').addClass("added");
            getWishlist(true);
            if($elem !== null) {
                $elem.addClass("added");
            }
        }
    }, function(status) {
        // error
    });
}

function removeFromWishList(productId, $elem = null) {
    if(typeof junoWishlistCustomer !== "undefined") {
        var url = 'http://pwaify.com/wishlist/?customer-id='+junoWishlistCustomer+'&type=set&update=remove&product-id=' + productId + '&shop='+junoWishlistStore;
        getJSON(url, function(data) {
            if (data.completed == "true") {
                // done
                $('#productWishListWrapper').removeClass("added");
                getWishlist(true);
                if($elem !== null) {
                    $elem.removeClass("added");
                }
            }
        }, function(status) {
            // error
        });
    } else {
        removeFromLocalWishList(productId);
    }

}

function getLocalStorageWishList() {
    var localWishlist = "";
    if (localStorage.getItem("junoWishList") !== null) {
        localWishlist = localStorage.getItem("junoWishList");
    }
    if(localWishlist == "") {
        return [];
    } else {
        return localWishlist.split(",");
    }
}

function addToLocalWishList(productId, $elem = null) {
    var currentWishList = getLocalStorageWishList();
    currentWishList.push(productId);
    localStorage.setItem("junoWishList", currentWishList.join(","));
    $('#productWishListWrapper').addClass("added");
    getWishlist(true);
    if($elem !== null) {
        $elem.addClass("added");
    }
}

function saveLocalWishList() {
    jQuery('#wishlistOutput').addClass("loading");
    var currentWishList = getLocalStorageWishList();
    url = 'http://pwaify.com/wishlist/local.php?product-ids='+JSON.stringify(currentWishList)+'&type=set&shop='+junoWishlistStore+'&customer-id='+junoWishlistCustomer;
    getJSON(url, function(data) {
        if (data.completed) {
            // done
            localStorage.removeItem("junoWishList");
            getWishlist(true);
        }
    }, function(status) {
        // error
    });
}

function removeFromLocalWishList(productId, $elem = null) {
    var currentWishList = getLocalStorageWishList();
    currentWishList.splice(currentWishList.indexOf(productId), 1);
    localStorage.setItem("junoWishList", currentWishList.join(","));
    $('#productWishListWrapper').removeClass("added");
    getWishlist(true);
    if($elem !== null) {
        $elem.removeClass("added");
    }
}

function highlightActiveWishListItems() {
    if(typeof junoWishlistCustomer === "undefined") { 
        var currentWishList = getLocalStorageWishList();
         if(currentWishList.length>0) {
            for(var i=0;i<currentWishList.length;i++) {
                jQuery('.collectionWishlistButton[data-id="'+currentWishList[i]+'"]').addClass("added");
            }
        }
    }   
}

function checkProductPageWishList() {
    if(typeof junoWishlistCustomer === "undefined") { 
        var currentWishList = getLocalStorageWishList();
         if(currentWishList.length>0) {
            for(var i=0;i<currentWishList.length;i++) {
                if(jQuery('#addToWishlist[data-id="'+currentWishList[i]+'"]').length>0) {
                    jQuery('#productWishListWrapper').addClass('added');
                }
            }
        }
    }   
}

jQuery(function() {
    
    
    
    if(typeof junoWishlistCustomer !== "undefined") {  
        var currentWishList = getLocalStorageWishList();  
        if(currentWishList.length>0) {
            saveLocalWishList();
        }
    } else {
        if(jQuery('#productWishListWrapper').length > 0) {
            checkProductPageWishList();
        }
    }

    jQuery('#addToWishlist').on('click', function(e){
        e.preventDefault();
        if(typeof junoWishlistCustomer !== "undefined") {
            addToWishList(jQuery(this).attr("data-id"));
        } else {
            addToLocalWishList(jQuery(this).attr("data-id"));
        }
    });

    jQuery("body").on("click", ".removeFromWishlist", function(e) {
        e.preventDefault();
        removeFromWishList(jQuery(this).attr('data-id'));
        // if on collection page, find the corresponding heart and untoggle it:
            jQuery('.collectionWishlistButton[data-id="'+jQuery(this).attr('data-id')+'"]').removeClass("added");
    });

    jQuery("body").on("click", ".wishListAddToCart", function() {
        var whichVariant;
        $parentButton = jQuery(this);
        var attr = jQuery(this).attr('data-variantid');

        if (typeof attr !== typeof undefined && attr !== false) {
            whichVariant = jQuery(this).attr('data-variantid');
        } else {
            // get selected variant
            whichVariant = jQuery(this).prev().find('select').val();
        }
        jQuery.post('/cart/add.js', { quantity: 1, id: whichVariant }, null, 'json').done(function(data) {
            // done
            $parentButton.html('added');
            setTimeout(function() { $parentButton.html('Add to cart'); }, 3000);
            ajaxCart.load();
        }).fail(function(data) {
            // error 
        });
    });

    jQuery("body").on("click", ".collectionWishlistButton", function(e) {
        e.preventDefault();
        if(jQuery(this).attr('data-account') == "true") {
            if(jQuery(this).hasClass("added")) {
                removeFromWishList(jQuery(this).attr('data-id'), jQuery(this));
            } else {
               addToWishList(jQuery(this).attr("data-id"), jQuery(this));
            }
        } else {
            // add to local storage:
            if(jQuery(this).hasClass("added")) {
                removeFromLocalWishList(jQuery(this).attr('data-id'), jQuery(this));
            } else {
               addToLocalWishList(jQuery(this).attr("data-id"), jQuery(this));
            }
        }
    });

    jQuery('#accountWishlistToggle').on('click', function(e){
        e.preventDefault();
        document.getElementById('wishlistToggle').click();
    });
});
/**
 * Featherlight - ultra slim jQuery lightbox
 * Version 1.7.1 - http://noelboss.github.io/featherlight/
 *
 * Copyright 2017, Noël Raoul Bossart (http://www.noelboss.com)
 * MIT Licensed.
**/
(function($) {
	"use strict";

	if('undefined' === typeof $) {
		if('console' in window){ window.console.info('Too much lightness, Featherlight needs jQuery.'); }
		return;
	}

	/* Featherlight is exported as $.featherlight.
	   It is a function used to open a featherlight lightbox.

	   [tech]
	   Featherlight uses prototype inheritance.
	   Each opened lightbox will have a corresponding object.
	   That object may have some attributes that override the
	   prototype's.
	   Extensions created with Featherlight.extend will have their
	   own prototype that inherits from Featherlight's prototype,
	   thus attributes can be overriden either at the object level,
	   or at the extension level.
	   To create callbacks that chain themselves instead of overriding,
	   use chainCallbacks.
	   For those familiar with CoffeeScript, this correspond to
	   Featherlight being a class and the Gallery being a class
	   extending Featherlight.
	   The chainCallbacks is used since we don't have access to
	   CoffeeScript's `super`.
	*/

	function Featherlight($content, config) {
		if(this instanceof Featherlight) {  /* called with new */
			this.id = Featherlight.id++;
			this.setup($content, config);
			this.chainCallbacks(Featherlight._callbackChain);
		} else {
			var fl = new Featherlight($content, config);
			fl.open();
			return fl;
		}
	}

	var opened = [],
		pruneOpened = function(remove) {
			opened = $.grep(opened, function(fl) {
				return fl !== remove && fl.$instance.closest('body').length > 0;
			} );
			return opened;
		};

	// Removes keys of `set` from `obj` and returns the removed key/values.
	function slice(obj, set) {
		var r = {};
		for (var key in obj) {
			if (key in set) {
				r[key] = obj[key];
				delete obj[key];
			}
		}
		return r;
	}

	// NOTE: List of available [iframe attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe).
	var iFrameAttributeSet = {
		allowfullscreen: 1, frameborder: 1, height: 1, longdesc: 1, marginheight: 1, marginwidth: 1,
		name: 1, referrerpolicy: 1, scrolling: 1, sandbox: 1, src: 1, srcdoc: 1, width: 1
	};

	// Converts camelCased attributes to dasherized versions for given prefix:
	//   parseAttrs({hello: 1, hellFrozeOver: 2}, 'hell') => {froze-over: 2}
	function parseAttrs(obj, prefix) {
		var attrs = {},
			regex = new RegExp('^' + prefix + '([A-Z])(.*)');
		for (var key in obj) {
			var match = key.match(regex);
			if (match) {
				var dasherized = (match[1] + match[2].replace(/([A-Z])/g, '-$1')).toLowerCase();
				attrs[dasherized] = obj[key];
			}
		}
		return attrs;
	}

	/* document wide key handler */
	var eventMap = { keyup: 'onKeyUp', resize: 'onResize' };

	var globalEventHandler = function(event) {
		$.each(Featherlight.opened().reverse(), function() {
			if (!event.isDefaultPrevented()) {
				if (false === this[eventMap[event.type]](event)) {
					event.preventDefault(); event.stopPropagation(); return false;
			  }
			}
		});
	};

	var toggleGlobalEvents = function(set) {
			if(set !== Featherlight._globalHandlerInstalled) {
				Featherlight._globalHandlerInstalled = set;
				var events = $.map(eventMap, function(_, name) { return name+'.'+Featherlight.prototype.namespace; } ).join(' ');
				$(window)[set ? 'on' : 'off'](events, globalEventHandler);
			}
		};

	Featherlight.prototype = {
		constructor: Featherlight,
		/*** defaults ***/
		/* extend featherlight with defaults and methods */
		namespace:      'featherlight',        /* Name of the events and css class prefix */
		targetAttr:     'data-featherlight',   /* Attribute of the triggered element that contains the selector to the lightbox content */
		variant:        null,                  /* Class that will be added to change look of the lightbox */
		resetCss:       false,                 /* Reset all css */
		background:     null,                  /* Custom DOM for the background, wrapper and the closebutton */
		openTrigger:    'click',               /* Event that triggers the lightbox */
		closeTrigger:   'click',               /* Event that triggers the closing of the lightbox */
		filter:         null,                  /* Selector to filter events. Think $(...).on('click', filter, eventHandler) */
		root:           'body',                /* Where to append featherlights */
		openSpeed:      250,                   /* Duration of opening animation */
		closeSpeed:     250,                   /* Duration of closing animation */
		closeOnClick:   'background',          /* Close lightbox on click ('background', 'anywhere' or false) */
		closeOnEsc:     true,                  /* Close lightbox when pressing esc */
		closeIcon:      '',            /* Close icon */
		loading:        '',                    /* Content to show while initial content is loading */
		persist:        false,                 /* If set, the content will persist and will be shown again when opened again. 'shared' is a special value when binding multiple elements for them to share the same content */
		otherClose:     null,                  /* Selector for alternate close buttons (e.g. "a.close") */
		beforeOpen:     $.noop,                /* Called before open. can return false to prevent opening of lightbox. Gets event as parameter, this contains all data */
		beforeContent:  $.noop,                /* Called when content is loaded. Gets event as parameter, this contains all data */
		beforeClose:    $.noop,                /* Called before close. can return false to prevent opening of lightbox. Gets event as parameter, this contains all data */
		afterOpen:      $.noop,                /* Called after open. Gets event as parameter, this contains all data */
		afterContent:   $.noop,                /* Called after content is ready and has been set. Gets event as parameter, this contains all data */
		afterClose:     $.noop,                /* Called after close. Gets event as parameter, this contains all data */
		onKeyUp:        $.noop,                /* Called on key up for the frontmost featherlight */
		onResize:       $.noop,                /* Called after new content and when a window is resized */
		type:           null,                  /* Specify type of lightbox. If unset, it will check for the targetAttrs value. */
		contentFilters: ['jquery', 'image', 'html', 'ajax', 'iframe', 'text'], /* List of content filters to use to determine the content */

		/*** methods ***/
		/* setup iterates over a single instance of featherlight and prepares the background and binds the events */
		setup: function(target, config){
			/* all arguments are optional */
			if (typeof target === 'object' && target instanceof $ === false && !config) {
				config = target;
				target = undefined;
			}

			var self = $.extend(this, config, {target: target}),
				css = !self.resetCss ? self.namespace : self.namespace+'-reset', /* by adding -reset to the classname, we reset all the default css */
				$background = $(self.background || [
					'<div class="'+css+'-loading '+css+'">',
						'<div class="'+css+'-content">',
							'<button class="'+css+'-close-icon '+ self.namespace + '-close" aria-label="Close">',
								self.closeIcon,
							'</button>',
							'<div class="'+self.namespace+'-inner">' + self.loading + '</div>',
						'</div>',
					'</div>'].join('')),
				closeButtonSelector = '.'+self.namespace+'-close' + (self.otherClose ? ',' + self.otherClose : '');

			self.$instance = $background.clone().addClass(self.variant); /* clone DOM for the background, wrapper and the close button */

			/* close when click on background/anywhere/null or closebox */
			self.$instance.on(self.closeTrigger+'.'+self.namespace, function(event) {
				var $target = $(event.target);
				if( ('background' === self.closeOnClick  && $target.is('.'+self.namespace))
					|| 'anywhere' === self.closeOnClick
					|| $target.closest(closeButtonSelector).length ){
					self.close(event);
					event.preventDefault();
				}
			});

			return this;
		},

		/* this method prepares the content and converts it into a jQuery object or a promise */
		getContent: function(){
			if(this.persist !== false && this.$content) {
				return this.$content;
			}
			var self = this,
				filters = this.constructor.contentFilters,
				readTargetAttr = function(name){ return self.$currentTarget && self.$currentTarget.attr(name); },
				targetValue = readTargetAttr(self.targetAttr),
				data = self.target || targetValue || '';

			/* Find which filter applies */
			var filter = filters[self.type]; /* check explicit type like {type: 'image'} */

			/* check explicit type like data-featherlight="image" */
			if(!filter && data in filters) {
				filter = filters[data];
				data = self.target && targetValue;
			}
			data = data || readTargetAttr('href') || '';

			/* check explicity type & content like {image: 'photo.jpg'} */
			if(!filter) {
				for(var filterName in filters) {
					if(self[filterName]) {
						filter = filters[filterName];
						data = self[filterName];
					}
				}
			}

			/* otherwise it's implicit, run checks */
			if(!filter) {
				var target = data;
				data = null;
				$.each(self.contentFilters, function() {
					filter = filters[this];
					if(filter.test)  {
						data = filter.test(target);
					}
					if(!data && filter.regex && target.match && target.match(filter.regex)) {
						data = target;
					}
					return !data;
				});
				if(!data) {
					if('console' in window){ window.console.error('Featherlight: no content filter found ' + (target ? ' for "' + target + '"' : ' (no target specified)')); }
					return false;
				}
			}
			/* Process it */
			return filter.process.call(self, data);
		},

		/* sets the content of $instance to $content */
		setContent: function($content){
			var self = this;
			/* we need a special class for the iframe */
			if($content.is('iframe')) {
				self.$instance.addClass(self.namespace+'-iframe');
			}

			self.$instance.removeClass(self.namespace+'-loading');

			/* replace content by appending to existing one before it is removed
			   this insures that featherlight-inner remain at the same relative
				 position to any other items added to featherlight-content */
			self.$instance.find('.'+self.namespace+'-inner')
				.not($content)                /* excluded new content, important if persisted */
				.slice(1).remove().end()      /* In the unexpected event where there are many inner elements, remove all but the first one */
				.replaceWith($.contains(self.$instance[0], $content[0]) ? '' : $content);

			self.$content = $content.addClass(self.namespace+'-inner');

			return self;
		},

		/* opens the lightbox. "this" contains $instance with the lightbox, and with the config.
			Returns a promise that is resolved after is successfully opened. */
		open: function(event){
			var self = this;
			self.$instance.hide().appendTo(self.root);
			if((!event || !event.isDefaultPrevented())
				&& self.beforeOpen(event) !== false) {

				if(event){
					event.preventDefault();
				}
				var $content = self.getContent();

				if($content) {
					opened.push(self);

					toggleGlobalEvents(true);

					self.$instance.fadeIn(self.openSpeed);
					self.beforeContent(event);

					/* Set content and show */
					return $.when($content)
						.always(function($content){
							self.setContent($content);
							self.afterContent(event);
						})
						.then(self.$instance.promise())
						/* Call afterOpen after fadeIn is done */
						.done(function(){ self.afterOpen(event); });
				}
			}
			self.$instance.detach();
			return $.Deferred().reject().promise();
		},

		/* closes the lightbox. "this" contains $instance with the lightbox, and with the config
			returns a promise, resolved after the lightbox is successfully closed. */
		close: function(event){
			var self = this,
				deferred = $.Deferred();

			if(self.beforeClose(event) === false) {
				deferred.reject();
			} else {

				if (0 === pruneOpened(self).length) {
					toggleGlobalEvents(false);
				}

				self.$instance.fadeOut(self.closeSpeed,function(){
					self.$instance.detach();
					self.afterClose(event);
					deferred.resolve();
				});
			}
			return deferred.promise();
		},

		/* resizes the content so it fits in visible area and keeps the same aspect ratio.
				Does nothing if either the width or the height is not specified.
				Called automatically on window resize.
				Override if you want different behavior. */
		resize: function(w, h) {
			if (w && h) {
				/* Reset apparent image size first so container grows */
				this.$content.css('width', '').css('height', '');
				/* Calculate the worst ratio so that dimensions fit */
				 /* Note: -1 to avoid rounding errors */
				var ratio = Math.max(
					w  / (parseInt(this.$content.parent().css('width'),10)-1),
					h / (parseInt(this.$content.parent().css('height'),10)-1));
				/* Resize content */
				if (ratio > 1) {
					ratio = h / Math.floor(h / ratio); /* Round ratio down so height calc works */
					this.$content.css('width', '' + w / ratio + 'px').css('height', '' + h / ratio + 'px');
				}
			}
		},

		/* Utility function to chain callbacks
		   [Warning: guru-level]
		   Used be extensions that want to let users specify callbacks but
		   also need themselves to use the callbacks.
		   The argument 'chain' has callback names as keys and function(super, event)
		   as values. That function is meant to call `super` at some point.
		*/
		chainCallbacks: function(chain) {
			for (var name in chain) {
				this[name] = $.proxy(chain[name], this, $.proxy(this[name], this));
			}
		}
	};

	$.extend(Featherlight, {
		id: 0,                                    /* Used to id single featherlight instances */
		autoBind:       '[data-featherlight]',    /* Will automatically bind elements matching this selector. Clear or set before onReady */
		defaults:       Featherlight.prototype,   /* You can access and override all defaults using $.featherlight.defaults, which is just a synonym for $.featherlight.prototype */
		/* Contains the logic to determine content */
		contentFilters: {
			jquery: {
				regex: /^[#.]\w/,         /* Anything that starts with a class name or identifiers */
				test: function(elem)    { return elem instanceof $ && elem; },
				process: function(elem) { return this.persist !== false ? $(elem) : $(elem).clone(true); }
			},
			image: {
				regex: /\.(png|jpg|jpeg|gif|tiff|bmp|svg)(\?\S*)?$/i,
				process: function(url)  {
					var self = this,
						deferred = $.Deferred(),
						img = new Image(),
						$img = $('<img src="'+url+'" alt="" class="'+self.namespace+'-image" />');
					img.onload  = function() {
						/* Store naturalWidth & height for IE8 */
						$img.naturalWidth = img.width; $img.naturalHeight = img.height;
						deferred.resolve( $img );
					};
					img.onerror = function() { deferred.reject($img); };
					img.src = url;
					return deferred.promise();
				}
			},
			html: {
				regex: /^\s*<[\w!][^<]*>/, /* Anything that starts with some kind of valid tag */
				process: function(html) { return $(html); }
			},
			ajax: {
				regex: /./,            /* At this point, any content is assumed to be an URL */
				process: function(url)  {
					var self = this,
						deferred = $.Deferred();
					/* we are using load so one can specify a target with: url.html #targetelement */
					var $container = $('<div></div>').load(url, function(response, status){
						if ( status !== "error" ) {
							deferred.resolve($container.contents());
						}
						deferred.fail();
					});
					return deferred.promise();
				}
			},
			iframe: {
				process: function(url) {
					var deferred = new $.Deferred();
					var $content = $('<iframe/>');
					var css = parseAttrs(this, 'iframe');
					var attrs = slice(css, iFrameAttributeSet);
					$content.hide()
						.attr('src', url)
						.attr(attrs)
						.css(css)
						.on('load', function() { deferred.resolve($content.show()); })
						// We can't move an <iframe> and avoid reloading it,
						// so let's put it in place ourselves right now:
						.appendTo(this.$instance.find('.' + this.namespace + '-content'));
					return deferred.promise();
				}
			},
			text: {
				process: function(text) { return $('<div>', {text: text}); }
			}
		},

		functionAttributes: ['beforeOpen', 'afterOpen', 'beforeContent', 'afterContent', 'beforeClose', 'afterClose'],

		/*** class methods ***/
		/* read element's attributes starting with data-featherlight- */
		readElementConfig: function(element, namespace) {
			var Klass = this,
				regexp = new RegExp('^data-' + namespace + '-(.*)'),
				config = {};
			if (element && element.attributes) {
				$.each(element.attributes, function(){
					var match = this.name.match(regexp);
					if (match) {
						var val = this.value,
							name = $.camelCase(match[1]);
						if ($.inArray(name, Klass.functionAttributes) >= 0) {  /* jshint -W054 */
							val = new Function(val);                           /* jshint +W054 */
						} else {
							try { val = JSON.parse(val); }
							catch(e) {}
						}
						config[name] = val;
					}
				});
			}
			return config;
		},

		/* Used to create a Featherlight extension
		   [Warning: guru-level]
		   Creates the extension's prototype that in turn
		   inherits Featherlight's prototype.
		   Could be used to extend an extension too...
		   This is pretty high level wizardy, it comes pretty much straight
		   from CoffeeScript and won't teach you anything about Featherlight
		   as it's not really specific to this library.
		   My suggestion: move along and keep your sanity.
		*/
		extend: function(child, defaults) {
			/* Setup class hierarchy, adapted from CoffeeScript */
			var Ctor = function(){ this.constructor = child; };
			Ctor.prototype = this.prototype;
			child.prototype = new Ctor();
			child.__super__ = this.prototype;
			/* Copy class methods & attributes */
			$.extend(child, this, defaults);
			child.defaults = child.prototype;
			return child;
		},

		attach: function($source, $content, config) {
			var Klass = this;
			if (typeof $content === 'object' && $content instanceof $ === false && !config) {
				config = $content;
				$content = undefined;
			}
			/* make a copy */
			config = $.extend({}, config);

			/* Only for openTrigger and namespace... */
			var namespace = config.namespace || Klass.defaults.namespace,
				tempConfig = $.extend({}, Klass.defaults, Klass.readElementConfig($source[0], namespace), config),
				sharedPersist;
			var handler = function(event) {
				/* ... since we might as well compute the config on the actual target */
				var elemConfig = $.extend(
					{$source: $source, $currentTarget: $(this)},
					Klass.readElementConfig($source[0], tempConfig.namespace),
					Klass.readElementConfig(this, tempConfig.namespace),
					config);
				var fl = sharedPersist || $(this).data('featherlight-persisted') || new Klass($content, elemConfig);
				if(fl.persist === 'shared') {
					sharedPersist = fl;
				} else if(fl.persist !== false) {
					$(this).data('featherlight-persisted', fl);
				}
				elemConfig.$currentTarget.blur(); // Otherwise 'enter' key might trigger the dialog again
				fl.open(event);
			};

			$source.on(tempConfig.openTrigger+'.'+tempConfig.namespace, tempConfig.filter, handler);

			return handler;
		},

		current: function() {
			var all = this.opened();
			return all[all.length - 1] || null;
		},

		opened: function() {
			var klass = this;
			pruneOpened();
			return $.grep(opened, function(fl) { return fl instanceof klass; } );
		},

		close: function(event) {
			var cur = this.current();
			if(cur) { return cur.close(event); }
		},

		/* Does the auto binding on startup.
		   Meant only to be used by Featherlight and its extensions
		*/
		_onReady: function() {
			var Klass = this;
			if(Klass.autoBind){
				/* Bind existing elements */
				$(Klass.autoBind).each(function(){
					Klass.attach($(this));
				});
				/* If a click propagates to the document level, then we have an item that was added later on */
				$(document).on('click', Klass.autoBind, function(evt) {
					if (evt.isDefaultPrevented()) {
						return;
					}
					/* Bind featherlight */
					var handler = Klass.attach($(evt.currentTarget));
					/* Dispatch event directly */
					handler(evt);
				});
			}
		},

		/* Featherlight uses the onKeyUp callback to intercept the escape key.
		   Private to Featherlight.
		*/
		_callbackChain: {
			onKeyUp: function(_super, event){
				if(27 === event.keyCode) {
					if (this.closeOnEsc) {
						$.featherlight.close(event);
					}
					return false;
				} else {
					return _super(event);
				}
			},

			beforeOpen: function(_super, event) {
				// Remember focus:
				this._previouslyActive = document.activeElement;

				// Disable tabbing:
				// See http://stackoverflow.com/questions/1599660/which-html-elements-can-receive-focus
				this._$previouslyTabbable = $("a, input, select, textarea, iframe, button, iframe, [contentEditable=true]")
					.not('[tabindex]')
					.not(this.$instance.find('button'));

				this._$previouslyWithTabIndex = $('[tabindex]').not('[tabindex="-1"]');
				this._previousWithTabIndices = this._$previouslyWithTabIndex.map(function(_i, elem) {
					return $(elem).attr('tabindex');
				});

				this._$previouslyWithTabIndex.add(this._$previouslyTabbable).attr('tabindex', -1);

				document.activeElement.blur();
				return _super(event);
			},

			afterClose: function(_super, event) {
				var r = _super(event);
				var self = this;
				this._$previouslyTabbable.removeAttr('tabindex');
				this._$previouslyWithTabIndex.each(function(i, elem) {
					$(elem).attr('tabindex', self._previousWithTabIndices[i]);
				});
				this._previouslyActive.focus();
				return r;
			},

			onResize: function(_super, event){
				this.resize(this.$content.naturalWidth, this.$content.naturalHeight);
				return _super(event);
			},

			afterContent: function(_super, event){
				var r = _super(event);
				this.$instance.find('[autofocus]:not([disabled])').focus();
				this.onResize(event);
				return r;
			}
		}
	});

	$.featherlight = Featherlight;

	/* bind jQuery elements to trigger featherlight */
	$.fn.featherlight = function($content, config) {
		Featherlight.attach(this, $content, config);
		return this;
	};

	/* bind featherlight on ready if config autoBind is set */
	$(document).ready(function(){ Featherlight._onReady(); });
}(jQuery));

/*! modernizr 3.4.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-csstransforms-flexbox-svg-setclasses !*/
!function(e,n,t){function r(e,n){return typeof e===n}function s(){var e,n,t,s,o,i,a;for(var l in w)if(w.hasOwnProperty(l)){if(e=[],n=w[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=r(n.fn,"function")?n.fn():n.fn,o=0;o<e.length;o++)i=e[o],a=i.split("."),1===a.length?Modernizr[a[0]]=s:(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=s),C.push((s?"":"no-")+a.join("-"))}}function o(e){var n=x.className,t=Modernizr._config.classPrefix||"";if(_&&(n=n.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(r,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),_?x.className.baseVal=n:x.className=n)}function i(e,n){return!!~(""+e).indexOf(n)}function a(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):_?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function l(e){return e.replace(/([a-z])-([a-z])/g,function(e,n,t){return n+t.toUpperCase()}).replace(/^-/,"")}function f(e,n){return function(){return e.apply(n,arguments)}}function u(e,n,t){var s;for(var o in e)if(e[o]in n)return t===!1?e[o]:(s=n[e[o]],r(s,"function")?f(s,t||n):s);return!1}function c(e){return e.replace(/([A-Z])/g,function(e,n){return"-"+n.toLowerCase()}).replace(/^ms-/,"-ms-")}function d(n,t,r){var s;if("getComputedStyle"in e){s=getComputedStyle.call(e,n,t);var o=e.console;if(null!==s)r&&(s=s.getPropertyValue(r));else if(o){var i=o.error?"error":"log";o[i].call(o,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else s=!t&&n.currentStyle&&n.currentStyle[r];return s}function p(){var e=n.body;return e||(e=a(_?"svg":"body"),e.fake=!0),e}function m(e,t,r,s){var o,i,l,f,u="modernizr",c=a("div"),d=p();if(parseInt(r,10))for(;r--;)l=a("div"),l.id=s?s[r]:u+(r+1),c.appendChild(l);return o=a("style"),o.type="text/css",o.id="s"+u,(d.fake?d:c).appendChild(o),d.appendChild(c),o.styleSheet?o.styleSheet.cssText=e:o.appendChild(n.createTextNode(e)),c.id=u,d.fake&&(d.style.background="",d.style.overflow="hidden",f=x.style.overflow,x.style.overflow="hidden",x.appendChild(d)),i=t(c,e),d.fake?(d.parentNode.removeChild(d),x.style.overflow=f,x.offsetHeight):c.parentNode.removeChild(c),!!i}function g(n,r){var s=n.length;if("CSS"in e&&"supports"in e.CSS){for(;s--;)if(e.CSS.supports(c(n[s]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var o=[];s--;)o.push("("+c(n[s])+":"+r+")");return o=o.join(" or "),m("@supports ("+o+") { #modernizr { position: absolute; } }",function(e){return"absolute"==d(e,null,"position")})}return t}function v(e,n,s,o){function f(){c&&(delete z.style,delete z.modElem)}if(o=r(o,"undefined")?!1:o,!r(s,"undefined")){var u=g(e,s);if(!r(u,"undefined"))return u}for(var c,d,p,m,v,y=["modernizr","tspan","samp"];!z.style&&y.length;)c=!0,z.modElem=a(y.shift()),z.style=z.modElem.style;for(p=e.length,d=0;p>d;d++)if(m=e[d],v=z.style[m],i(m,"-")&&(m=l(m)),z.style[m]!==t){if(o||r(s,"undefined"))return f(),"pfx"==n?m:!0;try{z.style[m]=s}catch(h){}if(z.style[m]!=v)return f(),"pfx"==n?m:!0}return f(),!1}function y(e,n,t,s,o){var i=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+E.join(i+" ")+i).split(" ");return r(n,"string")||r(n,"undefined")?v(a,n,s,o):(a=(e+" "+N.join(i+" ")+i).split(" "),u(a,n,t))}function h(e,n,r){return y(e,t,t,n,r)}var C=[],w=[],S={_version:"3.4.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){w.push({name:e,fn:n,options:t})},addAsyncTest:function(e){w.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=S,Modernizr=new Modernizr;var x=n.documentElement,_="svg"===x.nodeName.toLowerCase();Modernizr.addTest("svg",!!n.createElementNS&&!!n.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect);var b="Moz O ms Webkit",E=S._config.usePrefixes?b.split(" "):[];S._cssomPrefixes=E;var N=S._config.usePrefixes?b.toLowerCase().split(" "):[];S._domPrefixes=N;var P={elem:a("modernizr")};Modernizr._q.push(function(){delete P.elem});var z={style:P.elem.style};Modernizr._q.unshift(function(){delete z.style}),S.testAllProps=y,S.testAllProps=h,Modernizr.addTest("flexbox",h("flexBasis","1px",!0)),Modernizr.addTest("csstransforms",function(){return-1===navigator.userAgent.indexOf("Android 2.")&&h("transform","scale(1)",!0)}),s(),o(C),delete S.addTest,delete S.addAsyncTest;for(var T=0;T<Modernizr._q.length;T++)Modernizr._q[T]();e.Modernizr=Modernizr}(window,document);

/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
!function(a,b,c,d){function e(b,c){this.settings=null,this.options=a.extend({},e.Defaults,c),this.$element=a(b),this._handlers={},this._plugins={},this._supress={},this._current=null,this._speed=null,this._coordinates=[],this._breakpoint=null,this._width=null,this._items=[],this._clones=[],this._mergers=[],this._widths=[],this._invalidated={},this._pipe=[],this._drag={time:null,target:null,pointer:null,stage:{start:null,current:null},direction:null},this._states={current:{},tags:{initializing:["busy"],animating:["busy"],dragging:["interacting"]}},a.each(["onResize","onThrottledResize"],a.proxy(function(b,c){this._handlers[c]=a.proxy(this[c],this)},this)),a.each(e.Plugins,a.proxy(function(a,b){this._plugins[a.charAt(0).toLowerCase()+a.slice(1)]=new b(this)},this)),a.each(e.Workers,a.proxy(function(b,c){this._pipe.push({filter:c.filter,run:a.proxy(c.run,this)})},this)),this.setup(),this.initialize()}e.Defaults={items:3,loop:!1,center:!1,rewind:!1,checkVisibility:!0,mouseDrag:!0,touchDrag:!0,pullDrag:!0,freeDrag:!1,margin:0,stagePadding:0,merge:!1,mergeFit:!0,autoWidth:!1,startPosition:0,rtl:!1,smartSpeed:250,fluidSpeed:!1,dragEndSpeed:!1,responsive:{},responsiveRefreshRate:200,responsiveBaseElement:b,fallbackEasing:"swing",slideTransition:"",info:!1,nestedItemSelector:!1,itemElement:"div",stageElement:"div",refreshClass:"owl-refresh",loadedClass:"owl-loaded",loadingClass:"owl-loading",rtlClass:"owl-rtl",responsiveClass:"owl-responsive",dragClass:"owl-drag",itemClass:"owl-item",stageClass:"owl-stage",stageOuterClass:"owl-stage-outer",grabClass:"owl-grab"},e.Width={Default:"default",Inner:"inner",Outer:"outer"},e.Type={Event:"event",State:"state"},e.Plugins={},e.Workers=[{filter:["width","settings"],run:function(){this._width=this.$element.width()}},{filter:["width","items","settings"],run:function(a){a.current=this._items&&this._items[this.relative(this._current)]}},{filter:["items","settings"],run:function(){this.$stage.children(".cloned").remove()}},{filter:["width","items","settings"],run:function(a){var b=this.settings.margin||"",c=!this.settings.autoWidth,d=this.settings.rtl,e={width:"auto","margin-left":d?b:"","margin-right":d?"":b};!c&&this.$stage.children().css(e),a.css=e}},{filter:["width","items","settings"],run:function(a){var b=(this.width()/this.settings.items).toFixed(3)-this.settings.margin,c=null,d=this._items.length,e=!this.settings.autoWidth,f=[];for(a.items={merge:!1,width:b};d--;)c=this._mergers[d],c=this.settings.mergeFit&&Math.min(c,this.settings.items)||c,a.items.merge=c>1||a.items.merge,f[d]=e?b*c:this._items[d].width();this._widths=f}},{filter:["items","settings"],run:function(){var b=[],c=this._items,d=this.settings,e=Math.max(2*d.items,4),f=2*Math.ceil(c.length/2),g=d.loop&&c.length?d.rewind?e:Math.max(e,f):0,h="",i="";for(g/=2;g>0;)b.push(this.normalize(b.length/2,!0)),h+=c[b[b.length-1]][0].outerHTML,b.push(this.normalize(c.length-1-(b.length-1)/2,!0)),i=c[b[b.length-1]][0].outerHTML+i,g-=1;this._clones=b,a(h).addClass("cloned").appendTo(this.$stage),a(i).addClass("cloned").prependTo(this.$stage)}},{filter:["width","items","settings"],run:function(){for(var a=this.settings.rtl?1:-1,b=this._clones.length+this._items.length,c=-1,d=0,e=0,f=[];++c<b;)d=f[c-1]||0,e=this._widths[this.relative(c)]+this.settings.margin,f.push(d+e*a);this._coordinates=f}},{filter:["width","items","settings"],run:function(){var a=this.settings.stagePadding,b=this._coordinates,c={width:Math.ceil(Math.abs(b[b.length-1]))+2*a,"padding-left":a||"","padding-right":a||""};this.$stage.css(c)}},{filter:["width","items","settings"],run:function(a){var b=this._coordinates.length,c=!this.settings.autoWidth,d=this.$stage.children();if(c&&a.items.merge)for(;b--;)a.css.width=this._widths[this.relative(b)],d.eq(b).css(a.css);else c&&(a.css.width=a.items.width,d.css(a.css))}},{filter:["items"],run:function(){this._coordinates.length<1&&this.$stage.removeAttr("style")}},{filter:["width","items","settings"],run:function(a){a.current=a.current?this.$stage.children().index(a.current):0,a.current=Math.max(this.minimum(),Math.min(this.maximum(),a.current)),this.reset(a.current)}},{filter:["position"],run:function(){this.animate(this.coordinates(this._current))}},{filter:["width","position","items","settings"],run:function(){var a,b,c,d,e=this.settings.rtl?1:-1,f=2*this.settings.stagePadding,g=this.coordinates(this.current())+f,h=g+this.width()*e,i=[];for(c=0,d=this._coordinates.length;c<d;c++)a=this._coordinates[c-1]||0,b=Math.abs(this._coordinates[c])+f*e,(this.op(a,"<=",g)&&this.op(a,">",h)||this.op(b,"<",g)&&this.op(b,">",h))&&i.push(c);this.$stage.children(".active").removeClass("active"),this.$stage.children(":eq("+i.join("), :eq(")+")").addClass("active"),this.$stage.children(".center").removeClass("center"),this.settings.center&&this.$stage.children().eq(this.current()).addClass("center")}}],e.prototype.initializeStage=function(){this.$stage=this.$element.find("."+this.settings.stageClass),this.$stage.length||(this.$element.addClass(this.options.loadingClass),this.$stage=a("<"+this.settings.stageElement+">",{class:this.settings.stageClass}).wrap(a("<div/>",{class:this.settings.stageOuterClass})),this.$element.append(this.$stage.parent()))},e.prototype.initializeItems=function(){var b=this.$element.find(".owl-item");if(b.length)return this._items=b.get().map(function(b){return a(b)}),this._mergers=this._items.map(function(){return 1}),void this.refresh();this.replace(this.$element.children().not(this.$stage.parent())),this.isVisible()?this.refresh():this.invalidate("width"),this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)},e.prototype.initialize=function(){if(this.enter("initializing"),this.trigger("initialize"),this.$element.toggleClass(this.settings.rtlClass,this.settings.rtl),this.settings.autoWidth&&!this.is("pre-loading")){var a,b,c;a=this.$element.find("img"),b=this.settings.nestedItemSelector?"."+this.settings.nestedItemSelector:d,c=this.$element.children(b).width(),a.length&&c<=0&&this.preloadAutoWidthImages(a)}this.initializeStage(),this.initializeItems(),this.registerEventHandlers(),this.leave("initializing"),this.trigger("initialized")},e.prototype.isVisible=function(){return!this.settings.checkVisibility||this.$element.is(":visible")},e.prototype.setup=function(){var b=this.viewport(),c=this.options.responsive,d=-1,e=null;c?(a.each(c,function(a){a<=b&&a>d&&(d=Number(a))}),e=a.extend({},this.options,c[d]),"function"==typeof e.stagePadding&&(e.stagePadding=e.stagePadding()),delete e.responsive,e.responsiveClass&&this.$element.attr("class",this.$element.attr("class").replace(new RegExp("("+this.options.responsiveClass+"-)\\S+\\s","g"),"$1"+d))):e=a.extend({},this.options),this.trigger("change",{property:{name:"settings",value:e}}),this._breakpoint=d,this.settings=e,this.invalidate("settings"),this.trigger("changed",{property:{name:"settings",value:this.settings}})},e.prototype.optionsLogic=function(){this.settings.autoWidth&&(this.settings.stagePadding=!1,this.settings.merge=!1)},e.prototype.prepare=function(b){var c=this.trigger("prepare",{content:b});return c.data||(c.data=a("<"+this.settings.itemElement+"/>").addClass(this.options.itemClass).append(b)),this.trigger("prepared",{content:c.data}),c.data},e.prototype.update=function(){for(var b=0,c=this._pipe.length,d=a.proxy(function(a){return this[a]},this._invalidated),e={};b<c;)(this._invalidated.all||a.grep(this._pipe[b].filter,d).length>0)&&this._pipe[b].run(e),b++;this._invalidated={},!this.is("valid")&&this.enter("valid")},e.prototype.width=function(a){switch(a=a||e.Width.Default){case e.Width.Inner:case e.Width.Outer:return this._width;default:return this._width-2*this.settings.stagePadding+this.settings.margin}},e.prototype.refresh=function(){this.enter("refreshing"),this.trigger("refresh"),this.setup(),this.optionsLogic(),this.$element.addClass(this.options.refreshClass),this.update(),this.$element.removeClass(this.options.refreshClass),this.leave("refreshing"),this.trigger("refreshed")},e.prototype.onThrottledResize=function(){b.clearTimeout(this.resizeTimer),this.resizeTimer=b.setTimeout(this._handlers.onResize,this.settings.responsiveRefreshRate)},e.prototype.onResize=function(){return!!this._items.length&&(this._width!==this.$element.width()&&(!!this.isVisible()&&(this.enter("resizing"),this.trigger("resize").isDefaultPrevented()?(this.leave("resizing"),!1):(this.invalidate("width"),this.refresh(),this.leave("resizing"),void this.trigger("resized")))))},e.prototype.registerEventHandlers=function(){a.support.transition&&this.$stage.on(a.support.transition.end+".owl.core",a.proxy(this.onTransitionEnd,this)),!1!==this.settings.responsive&&this.on(b,"resize",this._handlers.onThrottledResize),this.settings.mouseDrag&&(this.$element.addClass(this.options.dragClass),this.$stage.on("mousedown.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("dragstart.owl.core selectstart.owl.core",function(){return!1})),this.settings.touchDrag&&(this.$stage.on("touchstart.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("touchcancel.owl.core",a.proxy(this.onDragEnd,this)))},e.prototype.onDragStart=function(b){var d=null;3!==b.which&&(a.support.transform?(d=this.$stage.css("transform").replace(/.*\(|\)| /g,"").split(","),d={x:d[16===d.length?12:4],y:d[16===d.length?13:5]}):(d=this.$stage.position(),d={x:this.settings.rtl?d.left+this.$stage.width()-this.width()+this.settings.margin:d.left,y:d.top}),this.is("animating")&&(a.support.transform?this.animate(d.x):this.$stage.stop(),this.invalidate("position")),this.$element.toggleClass(this.options.grabClass,"mousedown"===b.type),this.speed(0),this._drag.time=(new Date).getTime(),this._drag.target=a(b.target),this._drag.stage.start=d,this._drag.stage.current=d,this._drag.pointer=this.pointer(b),a(c).on("mouseup.owl.core touchend.owl.core",a.proxy(this.onDragEnd,this)),a(c).one("mousemove.owl.core touchmove.owl.core",a.proxy(function(b){var d=this.difference(this._drag.pointer,this.pointer(b));a(c).on("mousemove.owl.core touchmove.owl.core",a.proxy(this.onDragMove,this)),Math.abs(d.x)<Math.abs(d.y)&&this.is("valid")||(b.preventDefault(),this.enter("dragging"),this.trigger("drag"))},this)))},e.prototype.onDragMove=function(a){var b=null,c=null,d=null,e=this.difference(this._drag.pointer,this.pointer(a)),f=this.difference(this._drag.stage.start,e);this.is("dragging")&&(a.preventDefault(),this.settings.loop?(b=this.coordinates(this.minimum()),c=this.coordinates(this.maximum()+1)-b,f.x=((f.x-b)%c+c)%c+b):(b=this.settings.rtl?this.coordinates(this.maximum()):this.coordinates(this.minimum()),c=this.settings.rtl?this.coordinates(this.minimum()):this.coordinates(this.maximum()),d=this.settings.pullDrag?-1*e.x/5:0,f.x=Math.max(Math.min(f.x,b+d),c+d)),this._drag.stage.current=f,this.animate(f.x))},e.prototype.onDragEnd=function(b){var d=this.difference(this._drag.pointer,this.pointer(b)),e=this._drag.stage.current,f=d.x>0^this.settings.rtl?"left":"right";a(c).off(".owl.core"),this.$element.removeClass(this.options.grabClass),(0!==d.x&&this.is("dragging")||!this.is("valid"))&&(this.speed(this.settings.dragEndSpeed||this.settings.smartSpeed),this.current(this.closest(e.x,0!==d.x?f:this._drag.direction)),this.invalidate("position"),this.update(),this._drag.direction=f,(Math.abs(d.x)>3||(new Date).getTime()-this._drag.time>300)&&this._drag.target.one("click.owl.core",function(){return!1})),this.is("dragging")&&(this.leave("dragging"),this.trigger("dragged"))},e.prototype.closest=function(b,c){var e=-1,f=30,g=this.width(),h=this.coordinates();return this.settings.freeDrag||a.each(h,a.proxy(function(a,i){return"left"===c&&b>i-f&&b<i+f?e=a:"right"===c&&b>i-g-f&&b<i-g+f?e=a+1:this.op(b,"<",i)&&this.op(b,">",h[a+1]!==d?h[a+1]:i-g)&&(e="left"===c?a+1:a),-1===e},this)),this.settings.loop||(this.op(b,">",h[this.minimum()])?e=b=this.minimum():this.op(b,"<",h[this.maximum()])&&(e=b=this.maximum())),e},e.prototype.animate=function(b){var c=this.speed()>0;this.is("animating")&&this.onTransitionEnd(),c&&(this.enter("animating"),this.trigger("translate")),a.support.transform3d&&a.support.transition?this.$stage.css({transform:"translate3d("+b+"px,0px,0px)",transition:this.speed()/1e3+"s"+(this.settings.slideTransition?" "+this.settings.slideTransition:"")}):c?this.$stage.animate({left:b+"px"},this.speed(),this.settings.fallbackEasing,a.proxy(this.onTransitionEnd,this)):this.$stage.css({left:b+"px"})},e.prototype.is=function(a){return this._states.current[a]&&this._states.current[a]>0},e.prototype.current=function(a){if(a===d)return this._current;if(0===this._items.length)return d;if(a=this.normalize(a),this._current!==a){var b=this.trigger("change",{property:{name:"position",value:a}});b.data!==d&&(a=this.normalize(b.data)),this._current=a,this.invalidate("position"),this.trigger("changed",{property:{name:"position",value:this._current}})}return this._current},e.prototype.invalidate=function(b){return"string"===a.type(b)&&(this._invalidated[b]=!0,this.is("valid")&&this.leave("valid")),a.map(this._invalidated,function(a,b){return b})},e.prototype.reset=function(a){(a=this.normalize(a))!==d&&(this._speed=0,this._current=a,this.suppress(["translate","translated"]),this.animate(this.coordinates(a)),this.release(["translate","translated"]))},e.prototype.normalize=function(a,b){var c=this._items.length,e=b?0:this._clones.length;return!this.isNumeric(a)||c<1?a=d:(a<0||a>=c+e)&&(a=((a-e/2)%c+c)%c+e/2),a},e.prototype.relative=function(a){return a-=this._clones.length/2,this.normalize(a,!0)},e.prototype.maximum=function(a){var b,c,d,e=this.settings,f=this._coordinates.length;if(e.loop)f=this._clones.length/2+this._items.length-1;else if(e.autoWidth||e.merge){if(b=this._items.length)for(c=this._items[--b].width(),d=this.$element.width();b--&&!((c+=this._items[b].width()+this.settings.margin)>d););f=b+1}else f=e.center?this._items.length-1:this._items.length-e.items;return a&&(f-=this._clones.length/2),Math.max(f,0)},e.prototype.minimum=function(a){return a?0:this._clones.length/2},e.prototype.items=function(a){return a===d?this._items.slice():(a=this.normalize(a,!0),this._items[a])},e.prototype.mergers=function(a){return a===d?this._mergers.slice():(a=this.normalize(a,!0),this._mergers[a])},e.prototype.clones=function(b){var c=this._clones.length/2,e=c+this._items.length,f=function(a){return a%2==0?e+a/2:c-(a+1)/2};return b===d?a.map(this._clones,function(a,b){return f(b)}):a.map(this._clones,function(a,c){return a===b?f(c):null})},e.prototype.speed=function(a){return a!==d&&(this._speed=a),this._speed},e.prototype.coordinates=function(b){var c,e=1,f=b-1;return b===d?a.map(this._coordinates,a.proxy(function(a,b){return this.coordinates(b)},this)):(this.settings.center?(this.settings.rtl&&(e=-1,f=b+1),c=this._coordinates[b],c+=(this.width()-c+(this._coordinates[f]||0))/2*e):c=this._coordinates[f]||0,c=Math.ceil(c))},e.prototype.duration=function(a,b,c){return 0===c?0:Math.min(Math.max(Math.abs(b-a),1),6)*Math.abs(c||this.settings.smartSpeed)},e.prototype.to=function(a,b){var c=this.current(),d=null,e=a-this.relative(c),f=(e>0)-(e<0),g=this._items.length,h=this.minimum(),i=this.maximum();this.settings.loop?(!this.settings.rewind&&Math.abs(e)>g/2&&(e+=-1*f*g),a=c+e,(d=((a-h)%g+g)%g+h)!==a&&d-e<=i&&d-e>0&&(c=d-e,a=d,this.reset(c))):this.settings.rewind?(i+=1,a=(a%i+i)%i):a=Math.max(h,Math.min(i,a)),this.speed(this.duration(c,a,b)),this.current(a),this.isVisible()&&this.update()},e.prototype.next=function(a){a=a||!1,this.to(this.relative(this.current())+1,a)},e.prototype.prev=function(a){a=a||!1,this.to(this.relative(this.current())-1,a)},e.prototype.onTransitionEnd=function(a){if(a!==d&&(a.stopPropagation(),(a.target||a.srcElement||a.originalTarget)!==this.$stage.get(0)))return!1;this.leave("animating"),this.trigger("translated")},e.prototype.viewport=function(){var d;return this.options.responsiveBaseElement!==b?d=a(this.options.responsiveBaseElement).width():b.innerWidth?d=b.innerWidth:c.documentElement&&c.documentElement.clientWidth?d=c.documentElement.clientWidth:console.warn("Can not detect viewport width."),d},e.prototype.replace=function(b){this.$stage.empty(),this._items=[],b&&(b=b instanceof jQuery?b:a(b)),this.settings.nestedItemSelector&&(b=b.find("."+this.settings.nestedItemSelector)),b.filter(function(){return 1===this.nodeType}).each(a.proxy(function(a,b){b=this.prepare(b),this.$stage.append(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)},this)),this.reset(this.isNumeric(this.settings.startPosition)?this.settings.startPosition:0),this.invalidate("items")},e.prototype.add=function(b,c){var e=this.relative(this._current);c=c===d?this._items.length:this.normalize(c,!0),b=b instanceof jQuery?b:a(b),this.trigger("add",{content:b,position:c}),b=this.prepare(b),0===this._items.length||c===this._items.length?(0===this._items.length&&this.$stage.append(b),0!==this._items.length&&this._items[c-1].after(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)):(this._items[c].before(b),this._items.splice(c,0,b),this._mergers.splice(c,0,1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)),this._items[e]&&this.reset(this._items[e].index()),this.invalidate("items"),this.trigger("added",{content:b,position:c})},e.prototype.remove=function(a){(a=this.normalize(a,!0))!==d&&(this.trigger("remove",{content:this._items[a],position:a}),this._items[a].remove(),this._items.splice(a,1),this._mergers.splice(a,1),this.invalidate("items"),this.trigger("removed",{content:null,position:a}))},e.prototype.preloadAutoWidthImages=function(b){b.each(a.proxy(function(b,c){this.enter("pre-loading"),c=a(c),a(new Image).one("load",a.proxy(function(a){c.attr("src",a.target.src),c.css("opacity",1),this.leave("pre-loading"),!this.is("pre-loading")&&!this.is("initializing")&&this.refresh()},this)).attr("src",c.attr("src")||c.attr("data-src")||c.attr("data-src-retina"))},this))},e.prototype.destroy=function(){this.$element.off(".owl.core"),this.$stage.off(".owl.core"),a(c).off(".owl.core"),!1!==this.settings.responsive&&(b.clearTimeout(this.resizeTimer),this.off(b,"resize",this._handlers.onThrottledResize));for(var d in this._plugins)this._plugins[d].destroy();this.$stage.children(".cloned").remove(),this.$stage.unwrap(),this.$stage.children().contents().unwrap(),this.$stage.children().unwrap(),this.$stage.remove(),this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class",this.$element.attr("class").replace(new RegExp(this.options.responsiveClass+"-\\S+\\s","g"),"")).removeData("owl.carousel")},e.prototype.op=function(a,b,c){var d=this.settings.rtl;switch(b){case"<":return d?a>c:a<c;case">":return d?a<c:a>c;case">=":return d?a<=c:a>=c;case"<=":return d?a>=c:a<=c}},e.prototype.on=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d):a.attachEvent&&a.attachEvent("on"+b,c)},e.prototype.off=function(a,b,c,d){a.removeEventListener?a.removeEventListener(b,c,d):a.detachEvent&&a.detachEvent("on"+b,c)},e.prototype.trigger=function(b,c,d,f,g){var h={item:{count:this._items.length,index:this.current()}},i=a.camelCase(a.grep(["on",b,d],function(a){return a}).join("-").toLowerCase()),j=a.Event([b,"owl",d||"carousel"].join(".").toLowerCase(),a.extend({relatedTarget:this},h,c));return this._supress[b]||(a.each(this._plugins,function(a,b){b.onTrigger&&b.onTrigger(j)}),this.register({type:e.Type.Event,name:b}),this.$element.trigger(j),this.settings&&"function"==typeof this.settings[i]&&this.settings[i].call(this,j)),j},e.prototype.enter=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]===d&&(this._states.current[b]=0),this._states.current[b]++},this))},e.prototype.leave=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]--},this))},e.prototype.register=function(b){if(b.type===e.Type.Event){if(a.event.special[b.name]||(a.event.special[b.name]={}),!a.event.special[b.name].owl){var c=a.event.special[b.name]._default;a.event.special[b.name]._default=function(a){return!c||!c.apply||a.namespace&&-1!==a.namespace.indexOf("owl")?a.namespace&&a.namespace.indexOf("owl")>-1:c.apply(this,arguments)},a.event.special[b.name].owl=!0}}else b.type===e.Type.State&&(this._states.tags[b.name]?this._states.tags[b.name]=this._states.tags[b.name].concat(b.tags):this._states.tags[b.name]=b.tags,this._states.tags[b.name]=a.grep(this._states.tags[b.name],a.proxy(function(c,d){return a.inArray(c,this._states.tags[b.name])===d},this)))},e.prototype.suppress=function(b){a.each(b,a.proxy(function(a,b){this._supress[b]=!0},this))},e.prototype.release=function(b){a.each(b,a.proxy(function(a,b){delete this._supress[b]},this))},e.prototype.pointer=function(a){var c={x:null,y:null};return a=a.originalEvent||a||b.event,a=a.touches&&a.touches.length?a.touches[0]:a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:a,a.pageX?(c.x=a.pageX,c.y=a.pageY):(c.x=a.clientX,c.y=a.clientY),c},e.prototype.isNumeric=function(a){return!isNaN(parseFloat(a))},e.prototype.difference=function(a,b){return{x:a.x-b.x,y:a.y-b.y}},a.fn.owlCarousel=function(b){var c=Array.prototype.slice.call(arguments,1);return this.each(function(){var d=a(this),f=d.data("owl.carousel");f||(f=new e(this,"object"==typeof b&&b),d.data("owl.carousel",f),a.each(["next","prev","to","destroy","refresh","replace","add","remove"],function(b,c){f.register({type:e.Type.Event,name:c}),f.$element.on(c+".owl.carousel.core",a.proxy(function(a){a.namespace&&a.relatedTarget!==this&&(this.suppress([c]),f[c].apply(this,[].slice.call(arguments,1)),this.release([c]))},f))})),"string"==typeof b&&"_"!==b.charAt(0)&&f[b].apply(f,c)})},a.fn.owlCarousel.Constructor=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._interval=null,this._visible=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoRefresh&&this.watch()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={autoRefresh:!0,autoRefreshInterval:500},e.prototype.watch=function(){this._interval||(this._visible=this._core.isVisible(),this._interval=b.setInterval(a.proxy(this.refresh,this),this._core.settings.autoRefreshInterval))},e.prototype.refresh=function(){this._core.isVisible()!==this._visible&&(this._visible=!this._visible,this._core.$element.toggleClass("owl-hidden",!this._visible),this._visible&&this._core.invalidate("width")&&this._core.refresh())},e.prototype.destroy=function(){var a,c;b.clearInterval(this._interval);for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoRefresh=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._loaded=[],this._handlers={"initialized.owl.carousel change.owl.carousel resized.owl.carousel":a.proxy(function(b){if(b.namespace&&this._core.settings&&this._core.settings.lazyLoad&&(b.property&&"position"==b.property.name||"initialized"==b.type)){var c=this._core.settings,e=c.center&&Math.ceil(c.items/2)||c.items,f=c.center&&-1*e||0,g=(b.property&&b.property.value!==d?b.property.value:this._core.current())+f,h=this._core.clones().length,i=a.proxy(function(a,b){this.load(b)},this);for(c.lazyLoadEager>0&&(e+=c.lazyLoadEager,c.loop&&(g-=c.lazyLoadEager,e++));f++<e;)this.load(h/2+this._core.relative(g)),h&&a.each(this._core.clones(this._core.relative(g)),i),g++}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={lazyLoad:!1,lazyLoadEager:0},e.prototype.load=function(c){var d=this._core.$stage.children().eq(c),e=d&&d.find(".owl-lazy");!e||a.inArray(d.get(0),this._loaded)>-1||(e.each(a.proxy(function(c,d){var e,f=a(d),g=b.devicePixelRatio>1&&f.attr("data-src-retina")||f.attr("data-src")||f.attr("data-srcset");this._core.trigger("load",{element:f,url:g},"lazy"),f.is("img")?f.one("load.owl.lazy",a.proxy(function(){f.css("opacity",1),this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("src",g):f.is("source")?f.one("load.owl.lazy",a.proxy(function(){this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("srcset",g):(e=new Image,e.onload=a.proxy(function(){f.css({"background-image":'url("'+g+'")',opacity:"1"}),this._core.trigger("loaded",{element:f,url:g},"lazy")},this),e.src=g)},this)),this._loaded.push(d.get(0)))},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this._core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Lazy=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(c){this._core=c,this._previousHeight=null,this._handlers={"initialized.owl.carousel refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&this.update()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&"position"===a.property.name&&this.update()},this),"loaded.owl.lazy":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&a.element.closest("."+this._core.settings.itemClass).index()===this._core.current()&&this.update()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers),this._intervalId=null;var d=this;a(b).on("load",function(){d._core.settings.autoHeight&&d.update()}),a(b).resize(function(){d._core.settings.autoHeight&&(null!=d._intervalId&&clearTimeout(d._intervalId),d._intervalId=setTimeout(function(){d.update()},250))})};e.Defaults={autoHeight:!1,autoHeightClass:"owl-height"},e.prototype.update=function(){var b=this._core._current,c=b+this._core.settings.items,d=this._core.settings.lazyLoad,e=this._core.$stage.children().toArray().slice(b,c),f=[],g=0;a.each(e,function(b,c){f.push(a(c).height())}),g=Math.max.apply(null,f),g<=1&&d&&this._previousHeight&&(g=this._previousHeight),this._previousHeight=g,this._core.$stage.parent().height(g).addClass(this._core.settings.autoHeightClass)},e.prototype.destroy=function(){var a,b;for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoHeight=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._videos={},this._playing=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.register({type:"state",name:"playing",tags:["interacting"]})},this),"resize.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.video&&this.isInFullScreen()&&a.preventDefault()},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.is("resizing")&&this._core.$stage.find(".cloned .owl-video-frame").remove()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"===a.property.name&&this._playing&&this.stop()},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find(".owl-video");c.length&&(c.css("display","none"),this.fetch(c,a(b.content)))}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers),this._core.$element.on("click.owl.video",".owl-video-play-icon",a.proxy(function(a){this.play(a)},this))};e.Defaults={video:!1,videoHeight:!1,videoWidth:!1},e.prototype.fetch=function(a,b){var c=function(){return a.attr("data-vimeo-id")?"vimeo":a.attr("data-vzaar-id")?"vzaar":"youtube"}(),d=a.attr("data-vimeo-id")||a.attr("data-youtube-id")||a.attr("data-vzaar-id"),e=a.attr("data-width")||this._core.settings.videoWidth,f=a.attr("data-height")||this._core.settings.videoHeight,g=a.attr("href");if(!g)throw new Error("Missing video URL.");if(d=g.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/),d[3].indexOf("youtu")>-1)c="youtube";else if(d[3].indexOf("vimeo")>-1)c="vimeo";else{if(!(d[3].indexOf("vzaar")>-1))throw new Error("Video URL not supported.");c="vzaar"}d=d[6],this._videos[g]={type:c,id:d,width:e,height:f},b.attr("data-video",g),this.thumbnail(a,this._videos[g])},e.prototype.thumbnail=function(b,c){var d,e,f,g=c.width&&c.height?"width:"+c.width+"px;height:"+c.height+"px;":"",h=b.find("img"),i="src",j="",k=this._core.settings,l=function(c){e='<div class="owl-video-play-icon"></div>',d=k.lazyLoad?a("<div/>",{class:"owl-video-tn "+j,srcType:c}):a("<div/>",{class:"owl-video-tn",style:"opacity:1;background-image:url("+c+")"}),b.after(d),b.after(e)};if(b.wrap(a("<div/>",{class:"owl-video-wrapper",style:g})),this._core.settings.lazyLoad&&(i="data-src",j="owl-lazy"),h.length)return l(h.attr(i)),h.remove(),!1;"youtube"===c.type?(f="//img.youtube.com/vi/"+c.id+"/hqdefault.jpg",l(f)):"vimeo"===c.type?a.ajax({type:"GET",url:"//vimeo.com/api/v2/video/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a[0].thumbnail_large,l(f)}}):"vzaar"===c.type&&a.ajax({type:"GET",url:"//vzaar.com/api/videos/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a.framegrab_url,l(f)}})},e.prototype.stop=function(){this._core.trigger("stop",null,"video"),this._playing.find(".owl-video-frame").remove(),this._playing.removeClass("owl-video-playing"),this._playing=null,this._core.leave("playing"),this._core.trigger("stopped",null,"video")},e.prototype.play=function(b){var c,d=a(b.target),e=d.closest("."+this._core.settings.itemClass),f=this._videos[e.attr("data-video")],g=f.width||"100%",h=f.height||this._core.$stage.height();this._playing||(this._core.enter("playing"),this._core.trigger("play",null,"video"),e=this._core.items(this._core.relative(e.index())),this._core.reset(e.index()),c=a('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'),c.attr("height",h),c.attr("width",g),"youtube"===f.type?c.attr("src","//www.youtube.com/embed/"+f.id+"?autoplay=1&rel=0&v="+f.id):"vimeo"===f.type?c.attr("src","//player.vimeo.com/video/"+f.id+"?autoplay=1"):"vzaar"===f.type&&c.attr("src","//view.vzaar.com/"+f.id+"/player?autoplay=true"),a(c).wrap('<div class="owl-video-frame" />').insertAfter(e.find(".owl-video")),this._playing=e.addClass("owl-video-playing"))},e.prototype.isInFullScreen=function(){var b=c.fullscreenElement||c.mozFullScreenElement||c.webkitFullscreenElement;return b&&a(b).parent().hasClass("owl-video-frame")},e.prototype.destroy=function(){var a,b;this._core.$element.off("click.owl.video");for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Video=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this.core=b,this.core.options=a.extend({},e.Defaults,this.core.options),this.swapping=!0,this.previous=d,this.next=d,this.handlers={"change.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&(this.previous=this.core.current(),this.next=a.property.value)},this),"drag.owl.carousel dragged.owl.carousel translated.owl.carousel":a.proxy(function(a){a.namespace&&(this.swapping="translated"==a.type)},this),"translate.owl.carousel":a.proxy(function(a){a.namespace&&this.swapping&&(this.core.options.animateOut||this.core.options.animateIn)&&this.swap()},this)},this.core.$element.on(this.handlers)};e.Defaults={animateOut:!1,
animateIn:!1},e.prototype.swap=function(){if(1===this.core.settings.items&&a.support.animation&&a.support.transition){this.core.speed(0);var b,c=a.proxy(this.clear,this),d=this.core.$stage.children().eq(this.previous),e=this.core.$stage.children().eq(this.next),f=this.core.settings.animateIn,g=this.core.settings.animateOut;this.core.current()!==this.previous&&(g&&(b=this.core.coordinates(this.previous)-this.core.coordinates(this.next),d.one(a.support.animation.end,c).css({left:b+"px"}).addClass("animated owl-animated-out").addClass(g)),f&&e.one(a.support.animation.end,c).addClass("animated owl-animated-in").addClass(f))}},e.prototype.clear=function(b){a(b.target).css({left:""}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut),this.core.onTransitionEnd()},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this.core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Animate=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._call=null,this._time=0,this._timeout=0,this._paused=!0,this._handlers={"changed.owl.carousel":a.proxy(function(a){a.namespace&&"settings"===a.property.name?this._core.settings.autoplay?this.play():this.stop():a.namespace&&"position"===a.property.name&&this._paused&&(this._time=0)},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoplay&&this.play()},this),"play.owl.autoplay":a.proxy(function(a,b,c){a.namespace&&this.play(b,c)},this),"stop.owl.autoplay":a.proxy(function(a){a.namespace&&this.stop()},this),"mouseover.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"mouseleave.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.play()},this),"touchstart.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"touchend.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this.play()},this)},this._core.$element.on(this._handlers),this._core.options=a.extend({},e.Defaults,this._core.options)};e.Defaults={autoplay:!1,autoplayTimeout:5e3,autoplayHoverPause:!1,autoplaySpeed:!1},e.prototype._next=function(d){this._call=b.setTimeout(a.proxy(this._next,this,d),this._timeout*(Math.round(this.read()/this._timeout)+1)-this.read()),this._core.is("interacting")||c.hidden||this._core.next(d||this._core.settings.autoplaySpeed)},e.prototype.read=function(){return(new Date).getTime()-this._time},e.prototype.play=function(c,d){var e;this._core.is("rotating")||this._core.enter("rotating"),c=c||this._core.settings.autoplayTimeout,e=Math.min(this._time%(this._timeout||c),c),this._paused?(this._time=this.read(),this._paused=!1):b.clearTimeout(this._call),this._time+=this.read()%c-e,this._timeout=c,this._call=b.setTimeout(a.proxy(this._next,this,d),c-e)},e.prototype.stop=function(){this._core.is("rotating")&&(this._time=0,this._paused=!0,b.clearTimeout(this._call),this._core.leave("rotating"))},e.prototype.pause=function(){this._core.is("rotating")&&!this._paused&&(this._time=this.read(),this._paused=!0,b.clearTimeout(this._call))},e.prototype.destroy=function(){var a,b;this.stop();for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.autoplay=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(b){this._core=b,this._initialized=!1,this._pages=[],this._controls={},this._templates=[],this.$element=this._core.$element,this._overrides={next:this._core.next,prev:this._core.prev,to:this._core.to},this._handlers={"prepared.owl.carousel":a.proxy(function(b){b.namespace&&this._core.settings.dotsData&&this._templates.push('<div class="'+this._core.settings.dotClass+'">'+a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot")+"</div>")},this),"added.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,0,this._templates.pop())},this),"remove.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,1)},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&this.draw()},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&!this._initialized&&(this._core.trigger("initialize",null,"navigation"),this.initialize(),this.update(),this.draw(),this._initialized=!0,this._core.trigger("initialized",null,"navigation"))},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._initialized&&(this._core.trigger("refresh",null,"navigation"),this.update(),this.draw(),this._core.trigger("refreshed",null,"navigation"))},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers)};e.Defaults={nav:!1,navText:['<span aria-label="Previous">&#x2039;</span>','<span aria-label="Next">&#x203a;</span>'],navSpeed:!1,navElement:'button type="button" role="presentation"',navContainer:!1,navContainerClass:"owl-nav",navClass:["owl-prev","owl-next"],slideBy:1,dotClass:"owl-dot",dotsClass:"owl-dots",dots:!0,dotsEach:!1,dotsData:!1,dotsSpeed:!1,dotsContainer:!1},e.prototype.initialize=function(){var b,c=this._core.settings;this._controls.$relative=(c.navContainer?a(c.navContainer):a("<div>").addClass(c.navContainerClass).appendTo(this.$element)).addClass("disabled"),this._controls.$previous=a("<"+c.navElement+">").addClass(c.navClass[0]).html(c.navText[0]).prependTo(this._controls.$relative).on("click",a.proxy(function(a){this.prev(c.navSpeed)},this)),this._controls.$next=a("<"+c.navElement+">").addClass(c.navClass[1]).html(c.navText[1]).appendTo(this._controls.$relative).on("click",a.proxy(function(a){this.next(c.navSpeed)},this)),c.dotsData||(this._templates=[a('<button role="button">').addClass(c.dotClass).append(a("<span>")).prop("outerHTML")]),this._controls.$absolute=(c.dotsContainer?a(c.dotsContainer):a("<div>").addClass(c.dotsClass).appendTo(this.$element)).addClass("disabled"),this._controls.$absolute.on("click","button",a.proxy(function(b){var d=a(b.target).parent().is(this._controls.$absolute)?a(b.target).index():a(b.target).parent().index();b.preventDefault(),this.to(d,c.dotsSpeed)},this));for(b in this._overrides)this._core[b]=a.proxy(this[b],this)},e.prototype.destroy=function(){var a,b,c,d,e;e=this._core.settings;for(a in this._handlers)this.$element.off(a,this._handlers[a]);for(b in this._controls)"$relative"===b&&e.navContainer?this._controls[b].html(""):this._controls[b].remove();for(d in this.overides)this._core[d]=this._overrides[d];for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},e.prototype.update=function(){var a,b,c,d=this._core.clones().length/2,e=d+this._core.items().length,f=this._core.maximum(!0),g=this._core.settings,h=g.center||g.autoWidth||g.dotsData?1:g.dotsEach||g.items;if("page"!==g.slideBy&&(g.slideBy=Math.min(g.slideBy,g.items)),g.dots||"page"==g.slideBy)for(this._pages=[],a=d,b=0,c=0;a<e;a++){if(b>=h||0===b){if(this._pages.push({start:Math.min(f,a-d),end:a-d+h-1}),Math.min(f,a-d)===f)break;b=0,++c}b+=this._core.mergers(this._core.relative(a))}},e.prototype.draw=function(){var b,c=this._core.settings,d=this._core.items().length<=c.items,e=this._core.relative(this._core.current()),f=c.loop||c.rewind;this._controls.$relative.toggleClass("disabled",!c.nav||d),c.nav&&(this._controls.$previous.toggleClass("disabled",!f&&e<=this._core.minimum(!0)),this._controls.$next.toggleClass("disabled",!f&&e>=this._core.maximum(!0))),this._controls.$absolute.toggleClass("disabled",!c.dots||d),c.dots&&(b=this._pages.length-this._controls.$absolute.children().length,c.dotsData&&0!==b?this._controls.$absolute.html(this._templates.join("")):b>0?this._controls.$absolute.append(new Array(b+1).join(this._templates[0])):b<0&&this._controls.$absolute.children().slice(b).remove(),this._controls.$absolute.find(".active").removeClass("active"),this._controls.$absolute.children().eq(a.inArray(this.current(),this._pages)).addClass("active"))},e.prototype.onTrigger=function(b){var c=this._core.settings;b.page={index:a.inArray(this.current(),this._pages),count:this._pages.length,size:c&&(c.center||c.autoWidth||c.dotsData?1:c.dotsEach||c.items)}},e.prototype.current=function(){var b=this._core.relative(this._core.current());return a.grep(this._pages,a.proxy(function(a,c){return a.start<=b&&a.end>=b},this)).pop()},e.prototype.getPosition=function(b){var c,d,e=this._core.settings;return"page"==e.slideBy?(c=a.inArray(this.current(),this._pages),d=this._pages.length,b?++c:--c,c=this._pages[(c%d+d)%d].start):(c=this._core.relative(this._core.current()),d=this._core.items().length,b?c+=e.slideBy:c-=e.slideBy),c},e.prototype.next=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!0),b)},e.prototype.prev=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!1),b)},e.prototype.to=function(b,c,d){var e;!d&&this._pages.length?(e=this._pages.length,a.proxy(this._overrides.to,this._core)(this._pages[(b%e+e)%e].start,c)):a.proxy(this._overrides.to,this._core)(b,c)},a.fn.owlCarousel.Constructor.Plugins.Navigation=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(c){this._core=c,this._hashes={},this.$element=this._core.$element,this._handlers={"initialized.owl.carousel":a.proxy(function(c){c.namespace&&"URLHash"===this._core.settings.startPosition&&a(b).trigger("hashchange.owl.navigation")},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");if(!c)return;this._hashes[c]=b.content}},this),"changed.owl.carousel":a.proxy(function(c){if(c.namespace&&"position"===c.property.name){var d=this._core.items(this._core.relative(this._core.current())),e=a.map(this._hashes,function(a,b){return a===d?b:null}).join();if(!e||b.location.hash.slice(1)===e)return;b.location.hash=e}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers),a(b).on("hashchange.owl.navigation",a.proxy(function(a){var c=b.location.hash.substring(1),e=this._core.$stage.children(),f=this._hashes[c]&&e.index(this._hashes[c]);f!==d&&f!==this._core.current()&&this._core.to(this._core.relative(f),!1,!0)},this))};e.Defaults={URLhashListener:!1},e.prototype.destroy=function(){var c,d;a(b).off("hashchange.owl.navigation");for(c in this._handlers)this._core.$element.off(c,this._handlers[c]);for(d in Object.getOwnPropertyNames(this))"function"!=typeof this[d]&&(this[d]=null)},a.fn.owlCarousel.Constructor.Plugins.Hash=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){function e(b,c){var e=!1,f=b.charAt(0).toUpperCase()+b.slice(1);return a.each((b+" "+h.join(f+" ")+f).split(" "),function(a,b){if(g[b]!==d)return e=!c||b,!1}),e}function f(a){return e(a,!0)}var g=a("<support>").get(0).style,h="Webkit Moz O ms".split(" "),i={transition:{end:{WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",transition:"transitionend"}},animation:{end:{WebkitAnimation:"webkitAnimationEnd",MozAnimation:"animationend",OAnimation:"oAnimationEnd",animation:"animationend"}}},j={csstransforms:function(){return!!e("transform")},csstransforms3d:function(){return!!e("perspective")},csstransitions:function(){return!!e("transition")},cssanimations:function(){return!!e("animation")}};j.csstransitions()&&(a.support.transition=new String(f("transition")),a.support.transition.end=i.transition.end[a.support.transition]),j.cssanimations()&&(a.support.animation=new String(f("animation")),a.support.animation.end=i.animation.end[a.support.animation]),j.csstransforms()&&(a.support.transform=new String(f("transform")),a.support.transform3d=j.csstransforms3d())}(window.Zepto||window.jQuery,window,document);